[
  "4XLA Activator",
  "A-Phedrin",
  "A.E.R. Witch Hazel",
  "A+D Diaper Rash",
  "A+D Original",
  "Aagylur",
  "Aardora Anti-Fungal Maximum Strength",
  "Abecma",
  "Abelcet",
  "Abilify",
  "Abiraterone",
  "Abirtega",
  "Abraxane",
  "Abreva",
  "Abreva Rapid Pain Relief",
  "Abrilada",
  "Abrocitinib",
  "Abrysvo",
  "Absorbine",
  "Absorbine Jr.",
  "Absorbine Jr. Antifungal",
  "Absorbine Veterinary",
  "Absorbine Veterinary Liniment",
  "Absorica",
  "Abstral",
  "ACAM2000",
  "Acanya",
  "Acarbose",
  "Accolate",
  "Accrufer",
  "Accupril",
  "Accuretic",
  "Accutane",
  "Acenocoumarol",
  "Aceon",
  "Acephen",
  "Acetadote",
  "Acetadryl",
  "Acetazolamide",
  "Acetylcysteine",
  "Acid Gone",
  "Aciphex",
  "Acitretin",
  "Aclovate",
  "Acne-Clear",
  "Acneclir",
  "Acnevir",
  "AcneWorx",
  "Acnomel",
  "ACT Fluoride Rinse",
  "Actemra",
  "Acthar",
  "ActHIB",
  "Acticin",
  "Acticlate",
  "Actidose",
  "Actimmune",
  "Actiq",
  "Activase",
  "Activated Charcoal+Simethicone",
  "Active Q",
  "ActiveOxy",
  "ActivICE",
  "ActivOn Arthritis",
  "ActivOn Joint & Muscle",
  "Actonel",
  "Actoplus Met",
  "Actos",
  "Acular",
  "Acuvail",
  "Acyclovir",
  "Acyclovir cream",
  "Acyclovir eye",
  "Aczone",
  "Adacel",
  "Adakveo",
  "Adalimumab",
  "Adapalene",
  "Adasuve",
  "Adbry",
  "Adcetris",
  "Adcirca",
  "Addaprin",
  "Adderall",
  "Addyi",
  "Adefovir Dipivoxil",
  "Adempas",
  "Adenocard",
  "Adenoscan",
  "Adequan",
  "Adhansia",
  "Adipex-P",
  "Adlarity",
  "Admelog",
  "Adoxa",
  "Adrenalin",
  "Adrenaline (Epinephrine)",
  "Adriamycin",
  "Adrucil",
  "Adstiladrin",
  "Adthyza",
  "Aduhelm",
  "Advair",
  "Advanced Eye Relief Redness Instant Relief",
  "Advantage Multi",
  "Advantus",
  "Advate",
  "Advil",
  "Advocin",
  "Adynovate",
  "Adzenys",
  "Adzynma",
  "Aemcolo",
  "Aerospan",
  "Afatinib",
  "Afeditab CR",
  "Afinitor",
  "Afluria 2024-2025",
  "Afluria 2025-2026",
  "Afluria Quadrivalent 2022-2023",
  "Afluria Quadrivalent 2023-2024",
  "Afrezza",
  "Afrin",
  "Afstyla",
  "After banger",
  "After-bug",
  "Aftera",
  "Afterpill",
  "AfterPlan",
  "Agamree",
  "Aggrastat",
  "Agrimectin",
  "Agrimycin",
  "Agrylin",
  "Ahist Antihistamine",
  "Ahzantive",
  "Aimovig",
  "AirDuo",
  "Airmit",
  "Airsupra",
  "Ajovy",
  "AK-Con",
  "Akeega",
  "Aklief",
  "Akovaz",
  "Akten",
  "Akynzeo",
  "Ala Seb T",
  "Ala-Cort",
  "Ala-Hist IR",
  "Ala-Quin",
  "Ala-Scalp",
  "Alahist D",
  "Alavert",
  "Alavert D",
  "Alaway",
  "Albadry",
  "Albendazole",
  "Albenza",
  "Albon",
  "Albuked",
  "Albuminar",
  "Albuminex",
  "Alburx",
  "Albutein",
  "Alcaine",
  "Alcohol",
  "Alcortin",
  "Alcortin A",
  "Aldactazide",
  "Aldactone",
  "Aldara",
  "Aldesleukin, Interleukin 2",
  "Aldex AN",
  "Aldurazyme",
  "Alecensa",
  "Alectinib",
  "Alemtuzumab",
  "Alendronate Sodium",
  "Alevazol",
  "Aleve",
  "Aleve Arthritis Pain",
  "Aleve PM",
  "Alfacalcidol",
  "Alfaxan",
  "Alferon N",
  "Alfuzosin Hydrochloride",
  "Algal-900",
  "Alhemo",
  "Align",
  "Alimta",
  "Alinia",
  "Aliqopa",
  "Alirocumab",
  "Alitretinoin",
  "Alka-Mints",
  "Alka-Seltzer",
  "Alkeran",
  "Alkindi",
  "Alkums",
  "All Clear",
  "Allday",
  "Allegra",
  "Allegra-D",
  "Aller-Chlor",
  "Aller-Cort",
  "Aller-Flo",
  "Aller-Tec",
  "Aller-Tec D",
  "Allercaine",
  "Allerclear",
  "Allerest 12 Hour Nasal Spray",
  "AllerNaze",
  "Alleroff",
  "Allfen CX",
  "Allfen Jr",
  "Alli",
  "Allopurinol",
  "Alloxate",
  "Allzital",
  "Almacone",
  "Alo",
  "Alocane",
  "Alocane Anti-Itch",
  "Alocane Max Strength",
  "Alocane Plus",
  "Alocril",
  "Alodox",
  "Aloe Vesta Antifungal",
  "Aloe Vesta Daily Moisturizer",
  "Aloe Vesta Protective Barrier",
  "Aloe Vesta Skin Conditioner",
  "Alomide",
  "Alophen Reformulated Jan 2008",
  "Aloprim",
  "Alora",
  "Alpelisib",
  "Alpha-caine",
  "Alphagan",
  "Alphanate",
  "Alphanine SD",
  "Alprolix",
  "Alrex",
  "Altabax",
  "Altacaine",
  "Altace",
  "Altafluor",
  "Altalube",
  "Altamist",
  "Altazine",
  "Altoprev",
  "Altren",
  "Altreno",
  "Altuviiio",
  "Alunbrig",
  "Aluvea",
  "Alvaiz",
  "Alvesco",
  "Alyftrek",
  "Alyglo",
  "Alymsys",
  "Alyq",
  "Amantadine",
  "Amaryl",
  "Ambien",
  "Ambifed CD",
  "Ambifed-G CD",
  "AmBisome",
  "Ameluz",
  "Amerge",
  "Americaine",
  "Americaine Hemorrhoidal",
  "Amicar",
  "Amidate",
  "Amifampridine",
  "Amiloride",
  "Aminolaevulinic Acid",
  "Aminosyn 10%, Sulfite-Free",
  "Aminosyn 3.5 % M, Sulfite Free",
  "Aminosyn 7 % with Electrolytes, Sulfite-Free",
  "Aminosyn 8.5 % with Electrolytes, Sulfite-Free",
  "Aminosyn 8.5%, Sulfite-Free",
  "Aminosyn II 10 %",
  "Aminosyn II 15%",
  "Aminosyn II 7 %, Sulfite-Free",
  "Aminosyn II 8.5 % with Electrolytes, Sulfite-Free",
  "Aminosyn II 8.5 %, Sulfite-Free",
  "Aminosyn-HBC 7 %, Sulfite-Free",
  "Aminosyn-PF 10 %, Sulfite-Free",
  "Aminosyn-PF 7%",
  "Aminosyn-RF 5.2 %, Sulfite-Free",
  "Amiodarone Hydrochloride",
  "Amisulpride",
  "Amitiza",
  "Amitriptyline Hydrochloride",
  "Amjevita",
  "Amlactin",
  "AmLactin AP",
  "Amlodipine",
  "Amlodipine+Valsartan",
  "Ammonium Chloride+Diphenhydramine",
  "Ammonul",
  "Amnesteem",
  "Amondys 45",
  "Amoxi Drop",
  "Amoxi-tabs",
  "Amoxicillin",
  "Amphadase",
  "Ampicillin",
  "Amprid",
  "Amprol",
  "Ampromax",
  "AmproMed for Calves",
  "Ampromed-P",
  "Ampyra",
  "Amrix",
  "Amtagvi",
  "Amvisc",
  "Amvuttra",
  "Amytal",
  "Amzeeq",
  "Ana-Lex",
  "Anabar",
  "Anacaine",
  "Anacin",
  "Anacin Advanced Headache Formula",
  "Anacin AF",
  "Anacin Aspirin Regimen",
  "Anafranil",
  "Anagrelide Hydrochloride",
  "Analpram HC",
  "Anaprox",
  "Anascorp",
  "AnaSed",
  "Anasept",
  "Anaspaz",
  "Anastrozole",
  "Anavip",
  "Anbesol",
  "Anbesol Cold Sore Therapy",
  "Ancobon",
  "Andembry",
  "Andexxa",
  "Androderm",
  "Androgel",
  "AneCream",
  "Anectine",
  "Angiomax",
  "Animi-3 with Vitamin D",
  "Anipryl",
  "Anjeso",
  "Anktiva",
  "Annovera",
  "Anoro",
  "Ansaid",
  "Antabuse",
  "Antara",
  "Anthelcide EQ",
  "Anthim",
  "Anthrasil",
  "Anti Bac",
  "Anticholium",
  "ANTIROBE",
  "Antisedan",
  "Antivert",
  "Anucort-HC",
  "Anusol HC",
  "Anzemet",
  "Anzupgo",
  "Apadaz",
  "Apexicon",
  "Aphedrid",
  "Aphexda",
  "Apidra",
  "Apixaban",
  "Aplenzin",
  "Aplisol",
  "Apokyn",
  "Apomorphine",
  "Aponvie",
  "Apoquel",
  "Appearex",
  "Apraclonidine Hydrochloride",
  "Apremilast",
  "Aprepitant",
  "Apretude",
  "Apriso",
  "Aptensio",
  "Aptiom",
  "Aptivus",
  "Aqneursa",
  "Aqua Care",
  "Aqua Glycolic Shampoo and Body Cleanser",
  "Aqua-Ban",
  "Aquanil HC",
  "Aquaphilic with Urea",
  "Aquaphor",
  "Aquaphor Diaper Rash",
  "Aquaphor Itch Relief",
  "Aquasol A",
  "Aquasol E",
  "Aquosum Cream",
  "Aqvesme",
  "Arachis Oil+Soy Oil",
  "Arakoda",
  "Aralast",
  "Aranesp",
  "Arava",
  "Arazlo",
  "Arbli",
  "Arcalyst",
  "Arcticzen",
  "Arestin",
  "Arexvy",
  "Aricept",
  "Arikayce",
  "Arimidex",
  "Aripiprazole",
  "Aripiprazole-Abilify",
  "Aristada",
  "Arixtra",
  "Arkaliox",
  "Armodafinil",
  "Armonair",
  "Armour Thyroid",
  "Arnuity",
  "Aromasin",
  "Arovyn",
  "Arranon",
  "Artec",
  "Arth-RX",
  "Arthricare for Women Moisturizing",
  "Arthricare for Women Pain Relieving Nighttime",
  "Arthricare for Women Ultra Strength",
  "Arthriten Inflammatory Pain",
  "Arthritis Hot Pain Relief",
  "Arthrotec",
  "Arthur Itis",
  "Articadent",
  "Artiss",
  "Arymo",
  "Arynta",
  "Arzerra",
  "Asacol",
  "Ascarel",
  "Asceniv",
  "Asclera",
  "Ascomp",
  "Ascor",
  "Aservo",
  "Asfotase Alfa",
  "Asmanex",
  "Asparlas",
  "Aspercreme",
  "Aspergum",
  "Aspi-Cor",
  "Aspirin",
  "Aspirin+Caffeine+Paracetamol",
  "Aspruzyo",
  "Astagraf",
  "Astepro",
  "Asthmanefrin",
  "Astri-UC",
  "Astringyn",
  "Atacand",
  "Atacand HCT",
  "Atenolol",
  "Atezolizumab",
  "ATGAM",
  "Ativan",
  "Atmeksi",
  "Atomic Balm",
  "Atomoxetine",
  "Atopica",
  "Atorvaliq",
  "Atorvastatin",
  "Atorvastatin+Ezetimibe",
  "Atrac-Tain",
  "Atralin",
  "Atripla",
  "Atropen",
  "Atropine",
  "Atrovent",
  "ATryn",
  "Attruby",
  "Atzumi",
  "Aubagio",
  "Aucatzyl",
  "Audenz",
  "Augmentin",
  "Augtyro",
  "Aukelso",
  "Aulief",
  "Auraphene-B",
  "Aurlumyn",
  "Auro Ear",
  "Auryxia",
  "Austedo",
  "Auvelity",
  "Auvi-Q",
  "Avaclyr",
  "Avagard",
  "Availnex",
  "Avalide",
  "Avapro",
  "Avar",
  "Avastin",
  "Aveed",
  "Avelox",
  "Avgemsi",
  "Avidoxy",
  "Avita",
  "Avmapki",
  "Avoca",
  "Avodart",
  "Avonex",
  "Avopef",
  "Avsola",
  "Avtozma",
  "Avycaz",
  "Avzivi",
  "Axiron",
  "Axitinib",
  "Axtle",
  "Aygestin",
  "Ayr Saline Nasal",
  "Ayvakit",
  "Azacitidine",
  "Azactam",
  "Azasan",
  "AzaSite",
  "Azathioprine",
  "Azedra",
  "Azelastine Eye",
  "Azelastine Nose",
  "Azelex",
  "Azilect",
  "Azithromycin",
  "Azmiro",
  "Azo Urinary Pain Relief",
  "Azo Urinary Tract Defense",
  "Azopt",
  "Azor",
  "Azstarys",
  "Aztec Gold",
  "Azulfidine",
  "B-Caro-T",
  "B-Natal",
  "Babee Cof",
  "Baby Anti Monkey Butt Diaper Rash Cream",
  "Baby Butz Diaper Rash",
  "BabyBIG",
  "Baci-IM",
  "Baciguent",
  "Backaid",
  "Backaid IPF",
  "Backprin",
  "Baclofen",
  "Bactimicina",
  "Bactimicina Sore Throat",
  "Bactine",
  "Bactine Antibiotic",
  "Bactine Wound Wash",
  "Bactoshield",
  "Bactracillin G",
  "Bactrim",
  "Bactroban",
  "Bafiertam",
  "BAL in Oil",
  "Balfaxar",
  "Balmex",
  "Balmex Ointment",
  "Balnetar",
  "Balversa",
  "Banamine",
  "Band-Aid Hurt-Free",
  "Banophen",
  "Banophen Cream",
  "Banzel",
  "Baqsimi",
  "Baraclude",
  "Barhemsys",
  "Baridium",
  "Barrier-Dyne",
  "Basaglar",
  "Bavencio",
  "Baxdela",
  "Bayer Aspirin",
  "BAYTRIL",
  "Baytril Otic",
  "Baza",
  "Baza Cleanse and Protect",
  "Baza Clear",
  "Baza-Protect",
  "Baza-Protect Reformulated June 2020",
  "BC Arthritis",
  "BC Original Formula",
  "Beano",
  "Beano Dairy Defense",
  "Beconase",
  "Bedside-Care",
  "Beelith",
  "Beizray",
  "Belbuca",
  "Beleodaq",
  "Belrapzo",
  "Belsomra",
  "Belzutifan",
  "Benadryl",
  "Benadryl Allergy Plus Congestion",
  "Benadryl Children's Anti-Itch",
  "Benadryl Itch Stopping",
  "Benadryl-D Allergy and Sinus",
  "Bencocaine",
  "Bendeka",
  "Benefiber",
  "Benefiber Fiber",
  "BeneFIX",
  "Benicar",
  "Benicar HCT",
  "Benlysta",
  "Benralizumab",
  "Bensal",
  "Bentyl",
  "Benz-O-Sthetic",
  "Benzac",
  "Benzamycin",
  "Benzathine Benzylpenicillin  ",
  "Benzedrex",
  "Benzefoam",
  "Benzepro",
  "Benzo-Jel",
  "Benzocaine+Bismuth+Zinc Comp",
  "Benzodent",
  "Benzoyl Peroxide",
  "Benztropine",
  "Beovu",
  "Bepreve",
  "Beqvez",
  "Berberex Wound Cleanser",
  "Berinert",
  "Beser",
  "Besivance",
  "Besponsa",
  "Besremi",
  "Beta-HC",
  "Betacilin",
  "Betadine",
  "Betagan",
  "Betahistine",
  "Betamethasone",
  "Betamethasone Enema",
  "Betamethasone Esters",
  "Betamethasone injection",
  "Betamethasone+Salicylic Acid",
  "Betapace",
  "Betasept",
  "Betaseron",
  "Betatar Gel",
  "Betavet",
  "Betaxolol Hydrochloride",
  "Bethanechol Chloride",
  "Bethkis",
  "Betimol",
  "Betoptic S",
  "Bevacizumab",
  "Bevespi",
  "Bexacat",
  "Bexsero",
  "Beyfortus",
  "Bezafibrate",
  "Biaxin",
  "Bicarsim",
  "Bicillin",
  "Bicillin L-A",
  "Biclora",
  "BiCNU",
  "Bictegravir+Emtricitabine+Tenofovir Alafenamide",
  "Bidex",
  "Bidil",
  "Bifera",
  "BiferaRx",
  "Bifonazole",
  "Bifonazole+Fluocinonide",
  "Bigeloil",
  "Bijuva",
  "Biktarvy",
  "Bilastine",
  "Bildyos",
  "Bilovet",
  "Bilprevda",
  "Biltricide",
  "Bimasone",
  "Bimatoprost",
  "Bimectin",
  "Bimectin Plus",
  "Bimzelx",
  "Binosto",
  "Bio-Kool",
  "Bio-Mycin",
  "Bio-Statin",
  "Bioease Pain Relieving Cold Therapy",
  "Biofreeze",
  "BioGaia",
  "Biolon",
  "Biomox",
  "Bion Tears",
  "Bionect",
  "Biore",
  "Biorphen",
  "Biothrax",
  "Biotussin",
  "Biperiden",
  "Biphasic Insulin Lispro",
  "Bisac-Evac",
  "Bisacodyl",
  "Bismarex",
  "Bismusal",
  "Bismuth Subsalicylate",
  "Bisoprolol",
  "Bivigam",
  "Bizengri",
  "Bkemv",
  "Black Draught",
  "Blenrep",
  "Bleph-10",
  "Blephamide",
  "Blinatumomab",
  "Blincyto",
  "Blink Dry Eye",
  "Blink Tears",
  "Blis-To-Sol",
  "Blis-To-Sol Powder",
  "Blister Armour",
  "Bloxiverz",
  "Blu-Kote",
  "Bluemax",
  "Blujepa",
  "BOIL-EASE",
  "Bomyntra",
  "Boncresa",
  "Bonine",
  "Boniva",
  "Bonjesta",
  "Bonqat",
  "Bonsity",
  "Boostrix",
  "Booty Goo",
  "Boric Acid",
  "Boroleum",
  "Bortezomib",
  "Boruzu",
  "Bosaya",
  "Bosentan",
  "Bosulif",
  "Botox",
  "Botox Cosmetic",
  "Bovadine",
  "BovaPro",
  "BP 10-Wash",
  "BP Cleansing Wash",
  "Brace Relief",
  "Braftovi",
  "Bravecto",
  "Bravecto Plus",
  "Brekiya",
  "Brentuximab",
  "Brenzavvy",
  "Breo",
  "Brevibloc",
  "Brevital",
  "Brexafemme",
  "Breyanzi",
  "Breyna",
  "Breztri",
  "Bridion",
  "Brilinta",
  "Brimonidine Tartrate",
  "Brineura",
  "Brinsupri",
  "Brisdelle",
  "Briumvi",
  "Briviact",
  "Brixadi",
  "Broda Acne Spa",
  "Bromfed DM",
  "Bromhexine Hydrochloride",
  "Bromo Seltzer Antacid Pain Reliever",
  "Bromocriptine",
  "Bromsite",
  "Bronchitol",
  "Broncho Saline",
  "Bronkaid",
  "Bronkaid Max",
  "Brontex",
  "Brotizolam",
  "Brovana",
  "BroveX CB",
  "Brovex PBC",
  "Brukinsa",
  "Bruselix",
  "Bryhali",
  "Brynovin",
  "BSS Ophthalmic Solution",
  "Bucalsep",
  "Bucapsol",
  "Buckley's Bedtime Formula",
  "Buckley's Cough Suppressant",
  "Budesonide",
  "Budesonide+Formoterol",
  "Budesonide+Glycopyrronium+Formoterol",
  "Bufferin",
  "Bumex",
  "Bunavail",
  "Bupap",
  "Buphenyl",
  "Buprenex",
  "Buprenorphine Hydrochloride",
  "Bupropion-Wellbutrin",
  "Bupropion-Zyban",
  "Burn Jel Plus",
  "Buscopan",
  "Buserelin ",
  "Buspar",
  "Busulfex",
  "Butenafine Hydrochloride",
  "Butisol",
  "Butorphic",
  "BuTrans",
  "By Ache",
  "Bydureon",
  "Byetta",
  "Byfavo",
  "Bylvay",
  "Bynfezia",
  "Byooviz",
  "Byqlovi",
  "Bystolic",
  "Byvalson",
  "C-Time",
  "Cabergoline",
  "Cablivi",
  "Cabometyx",
  "Cabtreo",
  "Caduet",
  "Caelyx",
  "Cafcit",
  "Cafergot",
  "Cal Gest",
  "Cal-Quick",
  "Calaclear",
  "Caladryl",
  "Caladryl Clear",
  "Calagel",
  "Calagel Reformulated Jun 2019",
  "Calagesic",
  "Calamine+Zinc Oxide",
  "Calan",
  "Calcet",
  "Calcidol",
  "Calcipotriol",
  "Calcipotriol+Betamethasone",
  "Calcitonin",
  "Calcitrene",
  "Calcium Carbonate",
  "Calcium Carbonate+Magnesium Carbonate",
  "Calcium Disodium Versenate",
  "Calcium Folinate",
  "Caldecort",
  "Caldesene",
  "Caldolor",
  "Calgon Vesta",
  "Calgonate",
  "Callergy Clear",
  "Calmera",
  "Calmicid",
  "Calmodrox",
  "Calmol",
  "Calmoseptine",
  "Calphron",
  "Calprotect",
  "Calquence",
  "Caltrate",
  "Caltrate Gummy Bites",
  "Caltrate Plus D",
  "Cambia",
  "Camcevi",
  "Campath",
  "Campho-Phenique",
  "Camphor Ice",
  "Camptosar",
  "Camzyos",
  "Canalevia",
  "Canasa",
  "Cancidas",
  "Candee Caine",
  "Candesartan Cilexetil",
  "Candesartan+Hydrochlorothiazide",
  "CanineAid",
  "Caniquell",
  "Canker Care",
  "Canker Complete",
  "Canker Cover",
  "Cannabidiol",
  "Capacet",
  "Capaction",
  "Capecitabine",
  "Capex",
  "Caplacizumab",
  "Caplyta",
  "Caprelsa",
  "Caprieve",
  "Capstar",
  "Captopril",
  "Capvaxive",
  "Capzasin Quick Relief",
  "Capzasin-HP",
  "Capzasin-P",
  "Carac",
  "Carafate",
  "Carbaglu",
  "Carbamazepine",
  "Carbatrol",
  "Carbocaine",
  "Carbocaine with NeoCobefrin",
  "Carbocisteine",
  "Carbzah",
  "Cardalis",
  "Cardamyst",
  "Cardene",
  "Cardizem",
  "Cardura",
  "Carfilzomib",
  "Carmol",
  "Carmol Scalp",
  "Carni Q-Gel Forte",
  "Carnitine",
  "Carnitor",
  "Carofenvet",
  "Carospir",
  "Carprieve",
  "Carprovet",
  "Cartia",
  "Cartilade",
  "Carvedilol",
  "Carvykti",
  "Casgevy",
  "Casodex",
  "Castellani Paint",
  "Castiva Cooling",
  "Castiva Warming",
  "Cataflam",
  "Catapres",
  "Caverject",
  "Cayston",
  "Cefenil",
  "Cefotan",
  "Cefpoderm",
  "Ceftriaxone",
  "Cefuroxime",
  "Celadrin",
  "Celebrex",
  "Celecoxib",
  "Celestone Soluspan",
  "Celexa",
  "Cellcept",
  "Cellugel",
  "Celontin",
  "CEM-Urea",
  "Cemill 1000",
  "Cenobamate",
  "Centany",
  "Centragard",
  "Ceo-Two",
  "Cepacol",
  "Cepacol Antibacterial Mouthwash",
  "Cepacol Sore Throat from Post Nasal Drip",
  "Cepacol Sore Throat Pain Relief",
  "Cepacol Sore Throat Plus Cough",
  "Cepastat",
  "Cepastat Sore Throat & Cough",
  "Cephalexin",
  "Ceprotin",
  "Cequa",
  "CerAxon",
  "Cerdelga",
  "Cerebyx",
  "Cerenia",
  "Cerezyme",
  "Ceritant",
  "Certolizumab Pegol",
  "Cervidil",
  "Cesamet",
  "Cestex",
  "Cetacaine",
  "Cetafen",
  "Cetirizine Hydrochloride",
  "Cetraxal",
  "Cetrorelix",
  "Cetrotide",
  "Cetylpyridinium+Lidocaine",
  "Chamois Glide",
  "Chantix",
  "CharcoCaps",
  "Chem-Star Recover",
  "Chemet",
  "Chenodal",
  "Chenodeoxycholic Acid",
  "Cheracol with Codeine",
  "Cheratussin",
  "Chew Q",
  "CHG Teat Dip",
  "China-Gel",
  "Chirhostim",
  "Chlor-Trimeton",
  "Chloral Hydrate",
  "Chlorambucil",
  "Chloramphenicol",
  "ChloraPrep",
  "Chloraseptic",
  "Chloraseptic Max Spray",
  "Chloraseptic Sore Throat",
  "Chloraseptic Sore Throat + Cough",
  "Chloraseptic Spray",
  "Chlordiazepoxide+Clidinium Bromide",
  "Chlorhexidine Gluconate mouth",
  "Chlorhexidine-vaginal",
  "Chlorhexidine+Benzalkonium",
  "Chloromag",
  "Chloroquine Phosphate, Diphosphate",
  "Chlorpheniramine Maleate",
  "Chlorpheniramine+Phenylephrine ",
  "Chlorpromazine Hydrochloride",
  "Cholbam",
  "Cholestyramine",
  "Cholic Acid",
  "Chooz",
  "ChoreMate One-Shot",
  "Chorionic Gonadotropin recombinant",
  "Chorulon",
  "Chromelin",
  "Cialis",
  "Cibinqo",
  "Ciclodan",
  "Cicloferon",
  "Ciclopirox",
  "Cidacin",
  "Cidaflex",
  "CidalEaze",
  "Cilazapril",
  "Cilazapril+Hydrochlorothiazide",
  "Ciloxan",
  "Cimduo",
  "Cimerli",
  "Cimzia",
  "Cinacalcet",
  "Cinnarizine",
  "Cinqair",
  "Cinryze",
  "Cinvanti",
  "Cipro",
  "Cipro HC",
  "Ciprodex",
  "Ciprofibrate",
  "Ciprofloxacin",
  "Ciprofloxacin eye ear",
  "Citalopram",
  "Citanest",
  "Citanest Forte",
  "Citroma",
  "Citrucel",
  "Cladribine-Mavenclad",
  "Claforan",
  "Claravis",
  "Clarinex",
  "Clarinex-D",
  "Clarispray",
  "Clarithromycin",
  "Claritin",
  "Claritin Eye",
  "Claritin-D",
  "Clarus",
  "Clavacillin",
  "Clavamox",
  "Clavulanic Acid+Amoxicillin",
  "Cleanoz Saline",
  "clear days ahead",
  "Clear Proof Acne Medication",
  "Clear Proof Acne Treatment",
  "Clearcanal",
  "ClearLax",
  "Clearplex",
  "Clearskin",
  "Clearskin Blemish",
  "Clearskin Pore Penetrating Black Mineral Mask",
  "Clearskin Professional Daily Correcting",
  "Cleartime Indoor & Outdoor Allergies",
  "Cleeravue-M",
  "Clemasz",
  "Clemsza",
  "Clenia",
  "Clenpiq",
  "Clenziderm",
  "Clenziderm Lotion",
  "Cleocin",
  "Cleocin-T",
  "Cleviprex",
  "Climara",
  "Climara Pro",
  "Clinda-Guard",
  "Clindacin",
  "ClindaCure",
  "Clindagel",
  "Clindamax",
  "Clindamycin",
  "Clindamycin Dermal",
  "Clindamycin Vag",
  "Clindamycin+Benzoyl Peroxide",
  "Clindesse",
  "Clinidine",
  "Clinimix 4.25/10",
  "Clinimix 4.25/25",
  "Clinimix 4.25/5",
  "Clinimix 5/15",
  "Clinimix 5/20",
  "Clinimix 5/25",
  "Clinimix E 2.75/5",
  "Clinimix E 4.25/10",
  "Clinimix E 4.25/5",
  "Clinimix E 5/15",
  "Clinimix E 5/20",
  "Clinimix E 5/25",
  "Clinisol 15",
  "Clinolipid",
  "Clinpro 5000",
  "Clintabs",
  "Clobetasol Propionate",
  "Clobetasone Butyrate",
  "Clobex",
  "Clodan",
  "Cloderm",
  "Clolar",
  "Clomicalm",
  "Clomid",
  "Clomifene Citrate",
  "Clomipramine Hydrochloride",
  "Clonazepam",
  "Clonidine",
  "Clopidogrel",
  "Clorotekal",
  "Clorpactin WCS-90",
  "Clorpres",
  "Clotic",
  "Clotrimazole Oral",
  "Clotrimazole skin",
  "Clotrimazole Vaginal",
  "Clotrimazole+Gentamicin+Betamethasone",
  "Clovique",
  "Clozapine",
  "Clozaril",
  "CNJ-016",
  "Co-Trimoxazole",
  "Coagadex",
  "Coal Tar",
  "Coartem",
  "Cobenfy",
  "Cobimetinib",
  "Cocci-Cure C for Calves",
  "Cocci-Cure P for Poultry",
  "Codeine Phosphate",
  "Codeine+Caffeine+Paracetamol",
  "Codeine+Diphenhydramine+Pseudoephedrine",
  "Colace",
  "Colace w/Sennosides",
  "Colazal",
  "Colchicine",
  "Colcrys",
  "Cold Spot",
  "Colestid",
  "Colestipol Hydrochloride",
  "Colgate",
  "Colgate Total Mouthwash",
  "Columvi",
  "Coly Mycin M",
  "Combigan",
  "Combipatch",
  "Combivent",
  "Combivir",
  "Combogesic",
  "Cometriq",
  "Comfor-trate",
  "Comfort Caine",
  "Comfort Gel",
  "Comfort Shield",
  "Comfortcaine",
  "Comfortis",
  "Comfortlax",
  "Comirnaty",
  "Comirnaty 2023-2024",
  "Comirnaty 2024-2025",
  "Comirnaty 2025-2026",
  "Compazine",
  "Complera",
  "Compound W brand of salicylic acid",
  "Compoz",
  "Compro",
  "Compudose",
  "Comtan",
  "Comtrex Sore Throat Relief",
  "Conazol Miconazole",
  "Concept OB",
  "Conceptrol",
  "Concerta",
  "Condylox",
  "Conexxence",
  "Conjupri",
  "Consensi",
  "Constulose",
  "Contac Cold",
  "Contepo",
  "Contragesic",
  "Contrased",
  "Contrave",
  "Convenia",
  "ConZip",
  "Cool bottoms",
  "Copaxone",
  "Copiktra",
  "Cordarone",
  "Cordran",
  "Coreg",
  "Corgard",
  "CORID",
  "Corifact",
  "Corlanor",
  "Corlopam",
  "Cornstick",
  "Cornucrescine Daily Hoof Barrier",
  "Corona Multi-Purpose",
  "Corona Udder Butter",
  "Correct (New Formula)",
  "Correctol laxative Reformulated Feb 2008",
  "Cortaid",
  "Cortamine",
  "Cortane-B",
  "Cortef",
  "Cortenema",
  "Corticool",
  "Cortifoam",
  "Cortisone Acetate",
  "Cortisporin",
  "Cortisporin-TC",
  "Cortizone",
  "Cortrophin",
  "Corvert",
  "Cosamin",
  "Cosela",
  "Cosentyx",
  "Cosmegen",
  "Cosopt",
  "Cotellic",
  "Cotempla",
  "Cough Out",
  "Coumadin",
  "Counteract Cough Drops",
  "CounterAct Pain",
  "Covaryx",
  "Coxanto",
  "Coxiba",
  "Cozaar",
  "Cramergesic",
  "Credelio",
  "Crenessity",
  "Creomulsion",
  "Creon",
  "Cresemba",
  "Crest",
  "Crest Mouthwash",
  "Crestor",
  "Cresylate",
  "Crexont",
  "Crinone",
  "Critic-Aid Clear",
  "Critic-Aid Clear Moisture",
  "Critic-Aid Skin",
  "CroFab",
  "Cropamezole",
  "Crotamiton",
  "Crotan",
  "Cruex Antifungal",
  "Cruex Prescription Strength",
  "Crysvita",
  "Ctexli",
  "CTx3 Rinse",
  "Cuadriderma",
  "Cubicin",
  "Cuprimine",
  "Curae",
  "Curasore",
  "Curosurf",
  "Cutaquig",
  "Cutar",
  "Cutiecaine",
  "Cutivate",
  "Cuvitru",
  "Cuvposa",
  "Cuvrior",
  "Cyanokit",
  "Cyclavance",
  "Cyclogyl",
  "Cyclomydril",
  "Cyclopentolate Hydrochloride Eye Drops",
  "Cyclophosphamide",
  "Cycloserine",
  "Cycloset",
  "Cyclosporin",
  "Cydectin",
  "Cyfendus",
  "Cyklokapron",
  "Cylate",
  "Cyltezo",
  "Cymbalta",
  "Cyproterone Acetate",
  "Cyramza",
  "Cystadane",
  "Cystadrops",
  "Cystagon",
  "Cystaran",
  "Cystex",
  "Cystorelin",
  "Cytogam",
  "Cytomel",
  "Cytotec",
  "Cytra 2",
  "Cytra-3",
  "Cytra-K",
  "D-Cal",
  "D-Penamine",
  "D-Penicillamine",
  "D-Thrush",
  "D-Vi-Sol",
  "D3 Dots",
  "Dabigatran",
  "Daclatasvir",
  "Dacogen",
  "Dairyland Brand Controlled Iodine Teat Dip",
  "Daliresp",
  "Dallergy Reformulated Nov 2011",
  "Dalvance",
  "Danazol",
  "Dandrene",
  "Dandrex",
  "Dantrium",
  "Dantrolene",
  "Danyelza",
  "Danziten",
  "Dapagliflozin",
  "Dapagliflozin+Metformin",
  "Dapsone",
  "Daptacel",
  "Dapzura",
  "Daraprim",
  "Dartisla",
  "Darunavir",
  "Darzalex",
  "Darzalex Faspro",
  "Dasabuvir",
  "Dasatinib",
  "Datroway",
  "Daurismo",
  "Dawnzera",
  "Daxxify",
  "Daybue",
  "Dayhist-1",
  "Daypro",
  "DayQuil Cough",
  "Daytrana",
  "Dayvigo",
  "DDAVP",
  "Debacterol",
  "Debrox",
  "Decadron",
  "Decalcitrol",
  "Decara",
  "Dectogard",
  "Dectomax",
  "Deep Sea",
  "Defencath",
  "Defend II",
  "Defendazole",
  "Deferasirox",
  "Defitelio",
  "Del-Aqua",
  "Del-Beta",
  "Delaquin",
  "Delazinc",
  "Delestrogen",
  "Della Soft",
  "Delstrigo",
  "Delsym",
  "Delta D3",
  "Deltasone",
  "Delzicol",
  "Demerol",
  "Demser",
  "Denavir",
  "Dendracin Neurodendraxcin",
  "Dengvaxia",
  "Denorex Extra Strength Reformulated Aug 2012",
  "Denorex Therapeutic Reformulated Mar 2013",
  "Denosumab 120 mg",
  "Denosumab 60 mg",
  "Denta 5000 Plus",
  "Dentagel",
  "Dental Resources brand of Stannous Fluoride",
  "Dental Resources Perio Maintenance Rinse",
  "DentiCare Neutral",
  "Depakote",
  "Depen",
  "Depo-estradiol",
  "Depo-Medrol",
  "Depo-Provera",
  "depo-subQ provera",
  "Depo-testosterone",
  "Deramaxx",
  "Derifil",
  "Derma Gran",
  "Derma Gran Spray",
  "Derma Numb",
  "Derma-Smoothe FS",
  "Dermaceph",
  "DermaCerin",
  "Dermacort",
  "Dermafive",
  "Dermafix",
  "DermaFungal",
  "Dermagran",
  "Dermal-Soothe",
  "DermalZone",
  "Dermamycin",
  "Derman",
  "DermaPhor",
  "Dermaplex",
  "DermaSarra",
  "Dermasil",
  "Dermatin",
  "Dermatop",
  "Dermawound",
  "Dermawound Benzocaine",
  "Dermazene",
  "Dermazinc",
  "Dermeleve",
  "Dermoneen",
  "Dermoplast",
  "Dermoplast Antibacterial",
  "Dermoplast Pain",
  "Dermotic",
  "Dermtex HC",
  "Descovy",
  "Desempacho",
  "Desenex",
  "Desferal",
  "Desipramine Hydrochloride",
  "Desitin",
  "Desitin Clear",
  "Desloratadine",
  "Desmopressin Acetate ",
  "Desogestrel",
  "Desogestrel+Ethinyloestradiol",
  "Desowen",
  "Desoxyn",
  "Desquam",
  "Desrx",
  "Detomequin",
  "Detomised",
  "Detrol",
  "Devrom",
  "Dex4",
  "Dexamethasone",
  "Dexamethasone+Neomycin+Clotrimazole",
  "Dexamethasone+Neomycin+Polymyxin eye",
  "Dexased",
  "Dexasone",
  "Dexchlorpheniramine+Pseudoephedrine",
  "Dexdomitor",
  "Dexedrine",
  "Dexilant",
  "Dexium",
  "Dexlansoprazole",
  "Dexmedesed",
  "Dexmedvet",
  "Dexmethylphenidate",
  "Dexpanthenol",
  "Dexpanthenol+Chlorhexidine",
  "Dextenza",
  "Dextromethorphane+Ephedrine",
  "Dexycu",
  "Dhivy",
  "DHS Salicylic Acid 3%",
  "DHS Tar Shampoo",
  "DHS Zinc",
  "Di-Dak-Sol",
  "Diabetic Tussin EX",
  "Diacerein",
  "Diacomit",
  "Diaderm",
  "Dial Antibacterial",
  "Dial Dandruff Control",
  "Dialyvite 800",
  "Dialyvite 800 with Iron",
  "Dialyvite 800 with Zinc",
  "Dialyvite Vitamin D3 Max",
  "Diamode",
  "Dianeal Low Calcium 1.5",
  "Dianeal Low Calcium 2.5",
  "Dianeal Low Calcium 4.25",
  "Dianeal PD-2/1.5",
  "Dianeal PD-2/2.5",
  "Dianeal PD-2/4.25",
  "Diastat",
  "Diazepam",
  "Diazoxide",
  "Dibenzyline",
  "Dichlorobenzyl Alcohol+Amylmetacresol",
  "Diclegis",
  "Diclofenac",
  "Diclofenac Sodium eye",
  "Diclofenac Sodium topical",
  "Differin",
  "Differin Acne Clearing",
  "Dificid",
  "Difil G",
  "Diflucan",
  "Diflucortolone Valerate",
  "Diflucortolone valerate+Isoconazole",
  "Digex",
  "Digiclean E Foam",
  "DigiFab",
  "DigiSan E Foam",
  "Digitek",
  "Digox",
  "Digoxin",
  "Dilantin",
  "Dilaudid",
  "Dilaudid Cough",
  "Dilt",
  "Diltiazem",
  "Diltzac",
  "Dimenhydrinate",
  "Dimethindene Maleate",
  "Dimethindene Maleate gel",
  "Dimethyl Fumarate ",
  "Diovan",
  "Diovan HCT",
  "Dipentum",
  "Diphedryl",
  "Diphenhist",
  "Diprivan",
  "Diprolene",
  "Dipyridamole",
  "Dipyrone",
  "Disal",
  "Disalcid",
  "DisCoVisc",
  "Diskets",
  "Disodium Etidronate",
  "Disopyramide Phosphate",
  "Ditropan",
  "Diuril",
  "Divigel",
  "Doans",
  "Doans PM",
  "Docetaxel",
  "Docivyx",
  "Doctor's Choice",
  "Doculase",
  "Docusol",
  "Docusol Plus",
  "Dodex",
  "Dojolvi",
  "DOK",
  "Dolobid",
  "Dologesic",
  "Dolophine",
  "Doloracin with Lidocaine",
  "Dolorex Solution",
  "Dolutegravir+Lamivudine",
  "Domeboro",
  "Domperidone",
  "Donepezil",
  "Donnatal",
  "Dopram",
  "Doptelet",
  "Doracide",
  "Doraject",
  "Doral",
  "Dorama-Neo",
  "Doravirine",
  "Doravirine/Lamivudine/Tenofovir Disoproxil Fumarate",
  "Dormin",
  "DORMOSEDAN",
  "Doryx",
  "Dorzolamide+Timolol",
  "Dotti",
  "Douxo Micellar",
  "Dovato",
  "Dove DermaSeries",
  "Dove DermaSeries Eczema",
  "Dovonex",
  "Doxazosin",
  "Doxepin Hydrochloride",
  "Doxidyl",
  "Doxil",
  "Doxy",
  "Doxycycline Hydrochloride",
  "Doxylamine Succinate",
  "Doxylamine+Pyridoxine",
  "Dr. Smith's Diaper Rash",
  "Dr. Smith's Rash-n-All",
  "Dragon",
  "Dramamine",
  "Dramamine Less Drowsy",
  "Dramamine Nausea Relief",
  "Draxxin",
  "Draxxin KP",
  "Dream Pure BB",
  "Driminate",
  "Drisdol",
  "Dristan 12-Hour Nasal Spray",
  "Drithocreme",
  "Drizalma",
  "Droncit",
  "Dronedarone",
  "Drontal",
  "Drontal Plus",
  "Drospirenone+Ethinylestradiol",
  "Droxia",
  "Dry Clox",
  "Drysol",
  "Dsuvia",
  "Duaklir",
  "Duavee",
  "Duetact",
  "Duexis",
  "Dulaglutide",
  "Dulcolax",
  "Dulcolax Osmotic",
  "Dulera",
  "Duloxetine",
  "Duo Fusion",
  "Duobrii",
  "DuoCare Clinical",
  "Duodote",
  "Duofilm",
  "Duopa",
  "Duoplant",
  "Duotic",
  "Dupilumab",
  "Dupixent",
  "Duraclon",
  "Duraflor",
  "DuraMectin",
  "Duramist Plus",
  "Duramorph",
  "DuraPrep",
  "Durezol",
  "Durlaza",
  "Durolane",
  "Durysta",
  "Dutasteride",
  "Dutasteride+Tamsulosin",
  "Duvyzat",
  "Dvorah",
  "Dyanavel",
  "Dyazide",
  "Dyclopro",
  "Dydrogesterone",
  "Dymista",
  "Dyna-Hex",
  "Dynashield ZO",
  "Dyrenium",
  "Dysport",
  "E-Con",
  "E-R-O",
  "E-Z Scrub",
  "E-Z Scrub with Ultradex",
  "E-Z-Gas II",
  "E.E.S.",
  "Eagle Brand Medicated Oil",
  "Eazi-Breed CIDR",
  "Ebanga",
  "Ebglyss",
  "Eco-Gard",
  "Eco-Plus",
  "Ecoderm",
  "EContra",
  "Ecotrin",
  "Ecoza",
  "Eculizumab",
  "Eczemin",
  "Ed Flex",
  "Ed Spaz",
  "Edarbi",
  "Edarbyclor",
  "Edecrin",
  "Edex",
  "Edluar",
  "Edurant",
  "EDX-1000",
  "EDX-502",
  "Eescula",
  "Efavirenz",
  "Effaclar Duo",
  "Effer-K",
  "Effercept",
  "Effexor",
  "Effient",
  "Efodine",
  "Eformoterol-Formoterol Fumarate",
  "Efudex",
  "Egaten",
  "Egrifta",
  "Ekterly",
  "Elahere",
  "Elaprase",
  "Elavil",
  "Elcys",
  "Eldepryl",
  "Eldertonic",
  "Elelyso",
  "Elepsia",
  "Elestat",
  "Elestrin",
  "Eletriptan",
  "Elevidys",
  "Elexacaftor+Tezacaftor+Ivafactor",
  "Elfabrio",
  "Elidel",
  "Eligard",
  "Elimite",
  "Eliquis",
  "Elitek",
  "Elixophyllin",
  "Elixsure Cough",
  "Ella",
  "Ellence",
  "Ellis Tonic",
  "Elmiron",
  "Eloctate",
  "Elon Dual Defense",
  "Elrexfio",
  "Eltrombopag",
  "Elura",
  "EluRyng",
  "Elvitegravir+cobicistat+Emtricitabine+Tenofovir - Gendevra",
  "Elvitegravir+cobicistat+Emtricitabine+Tenofovir - Stribild",
  "Elyxyb",
  "Elzonris",
  "Emblaveo",
  "Emcin Clear",
  "Emcyt",
  "Emend",
  "Emend Injection",
  "Emeprev",
  "Emerphed",
  "Emetrol",
  "Emetrol Chewables",
  "Emetrol Powder",
  "Emflaza",
  "Emgality",
  "Emgel",
  "Empagliflozin",
  "Empagliflozin+Metformin",
  "Empaveli",
  "Empliciti",
  "Emrelis",
  "Emrosi",
  "Emsam",
  "Emtriva",
  "Emverm",
  "Enablex",
  "Enalapril Maleate",
  "Enbrel",
  "Enbumyst",
  "Encare",
  "Encelto",
  "Encora AM Tablet",
  "Encora Capsule",
  "Encora PM Tablet",
  "Encore",
  "End-Zit",
  "Endari",
  "Endocet",
  "Endometrin",
  "Endur-Acin",
  "Endur-Amide",
  "Endur-Thine",
  "Enemeez",
  "Enemeez Plus",
  "Enfamil Glucose",
  "Enflonsia",
  "Engerix-B",
  "Enhertu",
  "Enilloring",
  "Enjaymo",
  "Enlon",
  "Enlon-Plus",
  "Enoby",
  "Enoxaparin",
  "Enroflox",
  "Enromed",
  "Enropro",
  "Enropro Silver",
  "Enroquin",
  "Enrosite",
  "Enrosite Silver",
  "Ensacove",
  "Enspryng",
  "Enstilar",
  "Entacapone",
  "Entadfi",
  "Entereg",
  "Entocort",
  "Entresto",
  "ENTsol",
  "Entyce",
  "Entyvio",
  "Enulose",
  "Envarsus",
  "Enzalutamide",
  "Enzoclear",
  "Eohilia",
  "Epaned",
  "Epclusa",
  "Epidiolex",
  "Epiduo",
  "Epiflur",
  "Epifoam",
  "Epimide 50",
  "Epioxa",
  "Epipen",
  "EpiQuin Micro",
  "Epitol",
  "Epivir",
  "Epivir HBV",
  "Epkinly",
  "Eplerenone",
  "Epogen",
  "Eprigard",
  "Eprimectin",
  "Eprinex",
  "Eprizero",
  "Eprontia",
  "Epsolay",
  "Epysqli",
  "Epzicom",
  "Equagesic",
  "Equalactin",
  "Equetro",
  "Equi-Block LT Formula",
  "Equi-Block Original",
  "Equi-Phar",
  "Equicoxib",
  "Equidone",
  "Equimax",
  "EquineAid",
  "Equioxx",
  "Equistrength",
  "Equisul SDT",
  "Equizone",
  "Eraxis",
  "Erbitux",
  "Erdosteine",
  "Ergomar",
  "Eribulin",
  "Erivedge",
  "Erleada",
  "Erlotinib",
  "Ermeza",
  "Ertaczo",
  "Ervebo",
  "Erwinaze",
  "Ery",
  "Ery-Tab",
  "Erygel",
  "EryPed",
  "Erythrocin",
  "Erythrocin Stearate",
  "Erythromycin",
  "Erythromycin Dermal",
  "Erythromycin Eye",
  "Erythromycin-Benzoyl Peroxide",
  "Erythromycin+Tretinoin",
  "Erzofri",
  "Esbriet",
  "Escitalopram",
  "Esgic",
  "Eskata",
  "Esketamine",
  "Esomeprazole",
  "Esoterica",
  "Esperoct",
  "Estomaquil",
  "Estrace",
  "Estradiol",
  "Estradiol hemihydrate+Nomegestrol Acetate",
  "Estradiol patch",
  "Estradiol Vaginal",
  "Estradiol+Norethisterone",
  "Estramustine Phosphate",
  "Estratest",
  "Estring",
  "Estriol",
  "Estrogel",
  "Estroplan",
  "Estrumate",
  "Ethambutol Hydrochloride",
  "Ethamolin",
  "Ethinylestradiol+Drospirenone HRT",
  "Ethosuximide",
  "Ethyol",
  "Eticovo",
  "Etodolac",
  "Etonogestrel+Ethinylestradiol Ring",
  "Etopophos",
  "Etoposide",
  "Etoricoxib",
  "Eucamint",
  "Eucerin Calming Itch Relief",
  "Eucerin Eczema Relief",
  "Eucrisa",
  "Euflexxa",
  "Eulexin",
  "Eurax",
  "Euthaphen",
  "Euthasol",
  "Euthyrox",
  "Evac-U-Gen Reformulated Jan 2008",
  "Evamist",
  "EVARREST",
  "Evekeo",
  "Evenity",
  "Everclean",
  "Everolimus",
  "Evexithroid",
  "Evicel",
  "Evista",
  "Evithrom",
  "Evivo",
  "Evkeeza",
  "Evoclin",
  "Evolocumab",
  "Evomela",
  "Evotaz",
  "Evoxac",
  "Evrysdi",
  "Ex-Lax Chocolated",
  "Ex-Lax Maximum Relief Formula",
  "Ex-Lax Regular Strength Pills",
  "Ex-lax Ultra",
  "Exaprin",
  "Exaprin Plus",
  "Exblifep",
  "Excede",
  "Excedrin",
  "Excedrin Back & Body",
  "Excedrin Mild Headache",
  "Excedrin PM",
  "Excedrin PM Triple Action",
  "Excedrin Quick Tab",
  "Excedrin Tension Headache",
  "Excenel",
  "Exdensur",
  "Exelderm",
  "Exelon",
  "Exemestane",
  "Exenatide SR",
  "Exforge",
  "Exforge HCT",
  "Exidine",
  "Exjade",
  "Exkivity",
  "Exoderm",
  "Exodus",
  "Exondys",
  "Exparel",
  "Exservan",
  "Extavia",
  "Extencilline",
  "Extina",
  "Extraneal",
  "Exubera",
  "Exxua",
  "Eydenzelt",
  "Eye Stream",
  "Eyemycin",
  "Eyes Alive Lubricating",
  "Eylea",
  "Eysuvis",
  "Ezallor",
  "Ezetimibe",
  "EZFE",
  "Fabhalta",
  "Fabior",
  "Fabrazyme",
  "Factive",
  "Factrel",
  "Fakzynja",
  "Fallback Solo",
  "Famotidine",
  "Famvir",
  "Fanapt",
  "Fareston",
  "Farxiga",
  "Farydak",
  "Fasenra",
  "Faslodex",
  "Fast Freeze",
  "Fast Freeze Naturally Cool",
  "Fatal-Plus",
  "Febuxostat",
  "Feen-A-Mint Reformulated Jan 2008",
  "Feiba",
  "Felanorm",
  "Felbamate",
  "Felbatol",
  "Feldene",
  "Felimazole",
  "FelineAid",
  "Felycin",
  "Fem Choice",
  "Fem pH",
  "Femara",
  "Femhrt",
  "Femmesil",
  "Femring",
  "Fenfluramine Hydrochloride",
  "Fenoglide",
  "Fenopron",
  "Fensolvi",
  "Fentanyl",
  "Fentora",
  "Feosol",
  "Feosol Caplet",
  "Fer-in-Sol",
  "Feraheme",
  "Ferate",
  "Fergon",
  "Ferocon",
  "Ferralet 90",
  "Ferraplus",
  "Ferretts IPS",
  "Ferrex 150 Forte",
  "Ferrex 150 Forte Plus",
  "Ferrex 150 Plus",
  "Ferrex-150",
  "Ferric Hydroxide Polymaltose Complex",
  "Ferrimin 150",
  "Ferriprox",
  "Ferrlecit",
  "Ferrocite",
  "Ferrous Calcium Citrate",
  "Ferrous Fumarate+Folic Acid",
  "Ferrous Gluconate",
  "Fertagyl",
  "Fesilty",
  "Fesoterodine",
  "Fetroja",
  "Fetzima",
  "Feverall",
  "Fexmid",
  "Fexofenadine Hydrochloride",
  "Fiasp",
  "Fiber Choice",
  "Fiber Choice Weight Management",
  "Fiber Tab",
  "FiberCon",
  "Fibricor",
  "Fibryga",
  "Fidaxomicin",
  "Fidoquel",
  "Filgrastim",
  "Filspari",
  "Filsuvez",
  "Finacea",
  "Finafta Multi Oral",
  "Finasteride",
  "Finerenone",
  "Fintepla",
  "Fiore",
  "Fioricet",
  "Fioricet with Codeine",
  "Firazyr",
  "Firdapse",
  "Fire Out",
  "Firmagon",
  "Firovet",
  "Firox",
  "Firvanq",
  "Fisherman's Friend",
  "Flac",
  "Flagyl",
  "Flanders",
  "Flarex",
  "Flebogamma",
  "Flecainide Acetate",
  "Flector",
  "Fleqsuvy",
  "Fletchers Castoria",
  "Flexall",
  "Flexall Ultra Plus",
  "Flexbumin",
  "Flexira",
  "Flexprofen",
  "Flolan",
  "Flolipid",
  "Flomax",
  "Flonase",
  "Flonase Nighttime",
  "Flonase Sensimist",
  "Florajen",
  "Florajen3",
  "Florastor",
  "Florfeniject",
  "Florical",
  "Flovent",
  "Floxin",
  "Fluad 2024-2025",
  "Fluad 2025-2026",
  "Fluad Quadrivalent 2022-2023",
  "Fluad Quadrivalent 2023-2024",
  "Fluarix 2024-2025",
  "Fluarix 2025-2026",
  "Fluarix Quadrivalent 2022-2023",
  "Fluarix Quadrivalent 2023-2024",
  "Flublok 2024-2025",
  "Flublok 2025-2026",
  "Flublok Quadrivalent 2022-2023",
  "Flublok Quadrivalent 2023-2024",
  "Flucaine",
  "Flucelvax 2024-2025",
  "Flucelvax 2025-2026",
  "Flucelvax Quadrivalent 2022-2023",
  "Flucelvax Quadrivalent 2023-2024",
  "Fluconazole",
  "Fludrocortisone",
  "Flulaval 2024-2025",
  "Flulaval 2025-2026",
  "Flulaval Quadrivalent 2022-2023",
  "Flulaval Quadrivalent 2023-2024",
  "Flumadine",
  "Flumetasone-Salicyl",
  "FluMist 2024-2025",
  "FluMist 2025-2026",
  "FluMist Quadrivalent 2022-2023",
  "FluMist Quadrivalent 2023-2024",
  "Flunazine",
  "Flunine",
  "Fluor a Day",
  "Fluor a Day Chewable",
  "Fluorabon",
  "Fluoracaine",
  "Fluoridex",
  "Fluoridex Daily Defense Sensitivity",
  "Fluorimax",
  "Fluorimax Sensitive",
  "Fluorinse",
  "FluoriSHIELD",
  "Fluoritab",
  "Fluoroplex",
  "Fluoxetine Hydrochloride",
  "Flupentixol",
  "Fluphenazine Decanoate",
  "Fluphenazine Hydrochloride",
  "Flura-Drops",
  "Flurbiprofen",
  "Fluriso",
  "Fluroflox",
  "Fluroxin",
  "Fluticare",
  "Fluticasone Furoate Nasal",
  "Fluticasone Propionate",
  "Fluticasone Propionate Nasal",
  "Fluticasone+Vilanterol",
  "Fluvoxamine Maleate",
  "Fluzone 2024-2025",
  "Fluzone 2025 Southern Hemisphere",
  "Fluzone 2025-2026",
  "Fluzone Quadrivalent 2022-2023",
  "Fluzone Quadrivalent 2023-2024",
  "Fluzone Quadrivalent 2024 Southern Hemisphere",
  "Fluzone Quadrivalent 2025-2026",
  "FML",
  "FML Forte Liquifilm",
  "Focalin",
  "Focinvez",
  "Foille",
  "Folacin",
  "Folbecal",
  "Folbee",
  "Folbic",
  "Folditam",
  "Folgard",
  "Folgard OS",
  "Folic Acid",
  "FoliNatal Plus B",
  "Folitab",
  "Folivane-F",
  "Folixate",
  "Follistim",
  "Follitropin Alfa and Beta",
  "Folotyn",
  "Foltabs",
  "Foltrate",
  "Forane",
  "Forfivo",
  "Forma-Ray",
  "Formadon",
  "Formoterol+Beclomethasone",
  "Fortaz",
  "Forteo",
  "Fortesta",
  "Forzinity",
  "Fosamax",
  "Fosamax Plus D",
  "Foscavir",
  "Fosfomycin",
  "Fosrenol",
  "Fostex",
  "Fostex Bar",
  "Fotivda",
  "Four-Way",
  "Fragmin",
  "Freamine III 10",
  "Free and Clear",
  "Freez Eez",
  "Freeze It",
  "Freezone",
  "Frenadol",
  "Freshkote",
  "Frindovyx",
  "Frova",
  "Fruzaqla",
  "Fulphila",
  "Fulvestrant",
  "Fulvicin P/G",
  "Fungi-Gone",
  "Fungi-Guard",
  "Fungi-Nail",
  "Fungi-Nail Reformulated Mar 2019",
  "Fungi-Nail Toe and Foot",
  "FungiCure Maximum Strength",
  "Fungicure Solution",
  "Fungifoam",
  "Fungistat",
  "Fungizyl",
  "Fungoid",
  "Fungoid-D",
  "Furadantin",
  "Furoscix",
  "Furosemide",
  "Fusidic Acid, Sodium Fusidate eye",
  "Fusidic Acid/Sodium Fusidate",
  "Fusilev",
  "Fuzeon",
  "Fyarro",
  "Fyavolv",
  "FYCOMPA",
  "Fylnetra",
  "Fyremadel",
  "Gabapentin",
  "Gabarone",
  "Gabitril",
  "Gablofen",
  "Galafold",
  "Galantamine",
  "Gallifrey",
  "Galliprant",
  "Galzin",
  "GamaSTAN",
  "Gamifant",
  "Gammagard",
  "Gammagard ERC",
  "Gammaked",
  "Gammaplex",
  "Gamrozyne",
  "Gamunex",
  "Ganite",
  "Garasol",
  "Gardasil",
  "Gardasil 9",
  "Gas Aide",
  "Gas-X",
  "Gas-X Prevention",
  "Gas-X Total Relief",
  "Gas-X with Maalox",
  "Gastrocrom",
  "Gattex",
  "Gavilax",
  "GaviLyte-C",
  "Gavilyte-G",
  "Gavilyte-H",
  "GaviLyte-N",
  "Gaviscon",
  "Gaviscon Chewable",
  "Gavreto",
  "Gazyva",
  "Gefitinib",
  "Gel-Kam",
  "Gel-One",
  "Gel-Syn",
  "Gelato Anesthetic",
  "Gelato Perio Rinse",
  "Gelato sodium fluoride",
  "Gelnique",
  "Gelusil",
  "Gemcitabine",
  "Gemtesa",
  "Genac brand of pseudoephedrine/triprolidine",
  "Genahist",
  "Genaphed",
  "Generlac",
  "Genesis",
  "Gengraf",
  "Genone",
  "Genotropin",
  "Genpril",
  "Gentacalm",
  "Gentak",
  "Gentamicin Sulfate eye",
  "Gentamicin Sulphate inj",
  "Gentamicin+Betamethasone",
  "GentaVed",
  "GenTeal",
  "GentleLax",
  "Genvisc",
  "Genvoya",
  "Geodon",
  "Geri-Hydrolac",
  "Gestodene+Ethinyloestradiol",
  "Giapreza",
  "Giarcidia",
  "GiarcidiaZap-Wormer",
  "Gilenya",
  "Gilotrif",
  "Gimoti",
  "Gingi Med",
  "Givlaari",
  "Glassia",
  "Glatiramer Acetate",
  "Glatopa",
  "Glecaprevir+Pibrentasvir",
  "Gleevec",
  "Gleostine",
  "Gliadel",
  "Glibenclamide",
  "Glimepiride",
  "Glipizide",
  "Gloperba",
  "GlucaGen",
  "Glucagon",
  "Glucoburst",
  "Glucophage",
  "Glucosamine Sulfate",
  "Glucotrol",
  "Glumetza",
  "Glutamic-500",
  "Glutose",
  "Gly-Oxide",
  "Glycate",
  "Glycerin",
  "Glyceryl Trinitrate, Nitroglycerin",
  "Glycophos",
  "Glycopyrrolate",
  "Glycopyrronium",
  "Glycylic",
  "Glydo",
  "Glynase",
  "Glyrx",
  "Glyxambi",
  "Gocovri",
  "Gohibic",
  "Gold-Bloc",
  "Golytely",
  "Gomekli",
  "Gonabreed",
  "Gonal F",
  "Goniosoft",
  "Goniovisc",
  "Gonitro",
  "Goprelto",
  "Gordofilm",
  "Gordogesic",
  "Gormel",
  "Gormel 10",
  "Grafapex",
  "Gralise",
  "Granisetron",
  "Granisol",
  "Granix",
  "Granulotion Medicated Lotion",
  "Grastek",
  "Gravol",
  "Grazoprevir+Elbasvir",
  "Gris-PEG",
  "Griseofulvin",
  "Gvoke",
  "Gynazole-1",
  "Gynecort",
  "Gynol II",
  "H2Q",
  "Habitrol",
  "Hadlima",
  "Haegarda",
  "Halaven",
  "Halcion",
  "Haldol",
  "Halls",
  "Halls Breezers",
  "Halls Defense",
  "Haloette",
  "Halog",
  "Haloperidol",
  "Harliku",
  "Harvoni",
  "Havrix",
  "Head & Shoulders",
  "Head & Shoulders Clinical Strength",
  "Head & Shoulders Damage Treatment",
  "Head & Shoulders Scalp X",
  "Healon",
  "Healon5",
  "Healthy Mama",
  "HealthyLax",
  "Heartgard Plus",
  "Hectorol",
  "Helixate",
  "Hemabate",
  "Hemady",
  "Hemangeol",
  "Hematex",
  "Hematogen",
  "Hemax",
  "Hemgenix",
  "Hemiclor",
  "Hemlibra",
  "Hemmorex",
  "Hemocyte",
  "Hemocyte Plus",
  "Hemocyte-F",
  "Hemofil",
  "Hemorrodil Plus",
  "Hemox A",
  "Hemril",
  "HepaGam B",
  "Hepatamine 8",
  "Hepatitis B vaccine-SciBVac",
  "Heplisav-B",
  "Hepsera",
  "Hepzato",
  "Her Style",
  "Herceptin",
  "Herceptin Hylecta",
  "Hercessi",
  "Herklin",
  "Hernexeos",
  "Herzuma",
  "Hespan",
  "Hetlioz",
  "Hexa-Caine",
  "Hexatrione",
  "Hextend",
  "Hiberix",
  "Hibiclens",
  "Hibistat",
  "Hiprex",
  "hiVETIC",
  "Hizentra",
  "Homatropaire",
  "Hongo Killer",
  "Hongo Killer Antifungal",
  "Hongo Killer Treatment",
  "Hongo Killer Ultra",
  "Hooflex",
  "Horizant",
  "Horseman's Dream Fung-A-Way",
  "Hulio",
  "Humalog",
  "Humalog Mix",
  "Human Albumin Grifols",
  "Humate-P",
  "Humatin",
  "Humatrope",
  "Humira",
  "Humulin",
  "Humulin N",
  "Humulin R",
  "Hurricaine",
  "Hy-KXP",
  "Hyalgan",
  "HYALOVET",
  "HybriSil",
  "Hycamtin",
  "Hycet",
  "Hycodan",
  "Hycofenix",
  "Hydra-Neb",
  "Hydralazine Hydrochloride",
  "Hydrasyn25",
  "Hydrea",
  "Hydro 35",
  "Hydro 40",
  "Hydrochlorothiazide",
  "Hydrochlorothiazide+Amiloride",
  "Hydrocil",
  "Hydrocortisone",
  "Hydrocortisone Rectal Foam",
  "Hydrocortisone+Clotrimazole",
  "Hydrocortisone+Neomycin",
  "Hydromet",
  "Hydroquinidine",
  "Hydroxycarbamide",
  "Hydroxychloroquine Sulphate",
  "Hydroxyethylcellulose",
  "Hydroxyprogesterone Caproate Inj",
  "Hydroxyzine HCl",
  "Hyftor",
  "Hylenex",
  "Hylira",
  "Hymovis",
  "Hympavzi",
  "Hyophen",
  "Hyper-Sal",
  "Hypercare",
  "Hyperhep B",
  "HyperRAB",
  "HyperRHO",
  "Hypertet",
  "Hypotears",
  "Hypromellose",
  "Hypromellose [Cellulose Derive]-Dextran 70",
  "Hyrimoz",
  "Hyrnuo",
  "Hysept",
  "Hysingla",
  "Hyskon",
  "Hyvisc",
  "Hyzaar",
  "Ibrance",
  "Ibrutinib",
  "Ibsrela",
  "Ibtrozi",
  "Ibu",
  "Ibudone",
  "Ibuprofen",
  "Ibuprohm",
  "Icar",
  "Icar C",
  "Icar-C Plus",
  "Ichthammol",
  "Iclusig",
  "Idacio",
  "Idamycin",
  "IDELVION",
  "Idhifa",
  "iDose",
  "Iferex",
  "Iferex 150 Forte",
  "Ifex",
  "Igalmi",
  "Iheezo",
  "Ilaris",
  "Ilevro",
  "Ilex Skin",
  "Ilumya",
  "Iluvien",
  "Imaavy",
  "Imatinib",
  "Imbruvica",
  "Imcivree",
  "Imdelltra",
  "Imfinzi",
  "Imipramine Hydrochloride",
  "Imitrex",
  "Imizol",
  "Imjudo",
  "Imkeldi",
  "Imlygic",
  "Immphentiv",
  "Imodium",
  "Imodium Advanced",
  "Imodium Multi-Symptom Relief",
  "Imogam",
  "Imovax",
  "Imoxi",
  "Impavido",
  "Impeklo",
  "Impoyz",
  "Improvest",
  "Imuldosa",
  "Imuran",
  "Imvexxy",
  "Inbrija",
  "Increlex",
  "Increxxa",
  "Incruse",
  "Incurin",
  "Indapamide",
  "Inderal",
  "Indocin",
  "Indomethacin",
  "Infanrix",
  "Infasurf",
  "InFed",
  "Inflammation OTC Bruise",
  "Inflammation OTC Deep Pain Care",
  "Inflammation OTC Deep Pain Care Hot",
  "Inflectra",
  "Infliximab",
  "Infugem",
  "Infumorph",
  "Infuvite",
  "Infuvite Pediatric",
  "Ingenol Mebutate",
  "Ingrezza",
  "Injectafer",
  "Inlexzo",
  "Inluriyo",
  "Inlyta",
  "Inmazeb",
  "InnoPran",
  "INOmax",
  "Inon Ace Solution",
  "Inon Ace Tablet",
  "Inova",
  "Inova 8-2",
  "Inpefa",
  "Inqovi",
  "Inrebic",
  "Inspra",
  "Insta-Char",
  "Insta-Glucose",
  "Instacort",
  "Insulin Aspart",
  "Insulin Biphasic Aspart",
  "Insulin Degludec",
  "Insulin Degludec and Liraglutide ",
  "Insulin Detemir",
  "Insulin Glargine",
  "Insulin Glargine and Lixisenatide",
  "Insulin Glulisine",
  "Insulin Lispro",
  "Insulin lispro zinc crystal",
  "Insulin Soluble",
  "Insulin Zinc Suspension, Crystalline",
  "Integra F",
  "Intelence",
  "INTERCEPTOR",
  "Interceptor Plus",
  "Intestinex",
  "Intralipid",
  "Intrarosa",
  "Intuniv",
  "Invanz",
  "Invega",
  "Inveltys",
  "Inversedine",
  "Invokamet",
  "Invokana",
  "Inzirqo",
  "Inzo",
  "Io-Blend",
  "Io-Shield",
  "Iodex",
  "Iodine",
  "Iodip",
  "Iodoflex",
  "Iodopen",
  "Iodoshield",
  "Iodosorb",
  "Ionil Plus",
  "Ionil T",
  "Ionosol-B",
  "Ionosol-MB",
  "Ionsys",
  "Iopidine",
  "Iosat",
  "Ipilimumab",
  "IPM Wound",
  "Ipol",
  "Ipratropium Bromide",
  "Iprivask",
  "Iqirvo",
  "Irenka",
  "Iressa",
  "Irinotecan",
  "Irospan Tablet",
  "Isentress",
  "Isochron",
  "IsoDitrate",
  "Isolyte P",
  "Isolyte S",
  "Isolyte S in 5 % Dextrose",
  "Isoniazid",
  "Isoptin",
  "Isopto Alkaline",
  "Isopto Atropine",
  "Isopto Carbachol",
  "Isoptocarpine",
  "Isordil",
  "IsoSol",
  "Isosorbide Mononitrate",
  "Isospire",
  "Isotretinoin",
  "Istalol",
  "Istodax",
  "Isturisa",
  "Isuprel",
  "Itch-X",
  "Ithappenz",
  "Itovebi",
  "Itraconazole",
  "Itvisma",
  "Ivabradine",
  "Iverhart",
  "Iverhart Plus",
  "Ivermax",
  "Ivermax Plus",
  "Ivermectin",
  "iVizia",
  "Ivomec",
  "Ivomec Plus",
  "Ivra",
  "Ivy Block",
  "Ivy Dry Super Continuous Spray",
  "Ivy-Dry Cream",
  "Iwilfin",
  "Ixazomib",
  "Ixchiq",
  "Ixekizumab",
  "IXEMPRA",
  "Ixiaro",
  "Ixinity",
  "Iyuzeh",
  "Izervay",
  "Jadenu",
  "Jakafi",
  "Jalyn",
  "Jantoven",
  "Janumet",
  "Januvia",
  "Jardiance",
  "Jascayd",
  "Jatenzo",
  "Javadin",
  "Javygtor",
  "Jaypirca",
  "Jaythari",
  "Jelmyto",
  "Jemperli",
  "Jentadueto",
  "Jesduvroq",
  "Jet-Alert",
  "Jeuveau",
  "Jevantique",
  "Jevtana",
  "Jinteli",
  "Jivi",
  "Jobevne",
  "Jock-Eze",
  "Joenja",
  "Joint Formula 88 Max Plus",
  "Jointflex",
  "Jornay",
  "Journavx",
  "Jubbonti",
  "Jublia",
  "Julie",
  "Juluca",
  "Juxtapid",
  "Jylamvo",
  "Jynarque",
  "Jynneos",
  "K-Phos",
  "K-Phos Neutral",
  "K-Phos No 2",
  "K-Tab",
  "KADCYLA",
  "Kadian",
  "Kalbitor",
  "Kaletra",
  "Kalydeco",
  "Kanjinti",
  "Kanuma",
  "Kaopectate Reformulated Aug 2006",
  "Kapspargo",
  "Kapvay",
  "Karbinal",
  "Katerzia",
  "Katinko",
  "Kazano",
  "KBrovet",
  "Kcentra",
  "Kebilidi",
  "Kedbumin",
  "Kedrab",
  "Keepan",
  "Keflex",
  "Kenalog",
  "Kengreal",
  "Kepivance",
  "Keppra",
  "Kera Nail",
  "Kera-42",
  "Kera-HC",
  "Keralac",
  "Keralyt",
  "Keralyt 5",
  "Keratolux (piroctone)",
  "Kerendia",
  "Kerydin",
  "Kesimpta",
  "Kesium",
  "Ketalar",
  "Ketaset",
  "Keto-C",
  "Ketochlor",
  "Ketoconazole skin",
  "Ketodan",
  "Ketofen",
  "Ketomed",
  "Ketotifen",
  "Keveyis",
  "Kevzara",
  "Keystone",
  "Keytruda",
  "Keytruda Qlex",
  "Khapzory",
  "Khedezla",
  "Khindivi",
  "Kid's Choice",
  "Kids-Eeze Allergy",
  "Kids-Eeze Chest Relief",
  "Kimmtrak",
  "Kimyrsa",
  "Kinerase",
  "Kineret",
  "Kinevac",
  "Kinlytic",
  "Kinrix",
  "Kionex",
  "Kiprofen",
  "Kirsty",
  "Kisqali",
  "Kisunla",
  "Kitabis",
  "Klaron",
  "Kleer Plex",
  "Klentz",
  "Klisyri",
  "Klonopin",
  "Klor-Con",
  "Klor-Con/EF",
  "Kloxxado",
  "Koate",
  "Kodatef",
  "Kofal",
  "Kogenate",
  "Koldets Cough Drop",
  "Kolorz",
  "Kolorz Anesthetic",
  "Kombiglyze",
  "Komzifti",
  "Kondremul Plain",
  "Konsyl",
  "Konsyl Fiber",
  "Konvomep",
  "Kool-Down",
  "KOPERTOX",
  "Korlym",
  "Korsuva",
  "Koselugo",
  "Kourzeq",
  "Kovaltry",
  "Kovanaze",
  "Krazati",
  "Krintafel",
  "Kristalose",
  "Krystexxa",
  "Kuric",
  "Kuvan",
  "Kybella",
  "Kyleena",
  "Kymbee",
  "Kymriah",
  "Kynamro",
  "Kynmobi",
  "Kyprolis",
  "Kyxata",
  "Kyzatrex",
  "L-Formula",
  "Labetalol",
  "Lac-Hydrin",
  "Lacosamide",
  "Lacrisert",
  "Lactaid",
  "Lacticare",
  "Lactinol",
  "Lactocal",
  "Lactulose",
  "Lagevrio",
  "Lagicam",
  "Lamictal",
  "Lamisil",
  "Lamisil Defense",
  "Lamotrigine",
  "Lampit",
  "Lamzede",
  "Lanabiotic",
  "Lanacane",
  "Lanashield",
  "Lanoxin",
  "Lansinoh",
  "Lansoprazole",
  "Lantidra",
  "Lantiseptic",
  "Lantiseptic Multi-Purpose",
  "Lantiseptic Nourishing Skin",
  "Lantiseptic Protective",
  "Lantus",
  "Lapatinib",
  "Lasix",
  "Lasolex",
  "Lastacaft",
  "Latanoprost",
  "Latisse",
  "Latrix",
  "Latuda",
  "Lavender oil Silexan",
  "Laverdia",
  "Laxacin",
  "Laxomil",
  "Lazanda",
  "Lazcluze",
  "Leflunomide",
  "Legatrin PM",
  "Legend",
  "Lemborexant",
  "Lemtrada",
  "Lenacapavir",
  "Lenalidomide",
  "Lenmeldy",
  "Lentocilin",
  "Lenvatinib",
  "Lenvima",
  "Lenzagel",
  "Lenzapatch",
  "Leqembi",
  "Leqselvi",
  "Leqvio",
  "Lercanidipine",
  "Lerochol",
  "Lescol",
  "Letairis",
  "Letrozole",
  "Letybo",
  "Leukeran",
  "Leukine",
  "Levafen",
  "Levaquin",
  "Levbid",
  "Levemir",
  "Levetiracetam",
  "Levitra",
  "Levo-T",
  "Levodopa+Benserazide ",
  "Levodopa+Carbidopa",
  "Levodopa+Carbidopa intestinal gel",
  "Levofloxacin",
  "Levonorgestrel (התקן תוך־רחמי - IUD) ",
  "Levonorgestrel-ECP",
  "Levophed",
  "Levothyroxine Sodium 2012",
  "Levoxyl",
  "Levsin",
  "Levulan",
  "Lexapro",
  "Lexette",
  "Lexinal",
  "Lexiva",
  "Lialda",
  "Libervant",
  "Librax",
  "Libtayo",
  "Licart",
  "Lido King",
  "Lidocaine Topical",
  "Lidocaine+Prilocaine",
  "Lidocaine+Tribenoside",
  "Lidocaine+Tyrothricin+Cetrimonium",
  "Lidocan",
  "Lidocare",
  "Lidocream",
  "Lidoderm",
  "Lidoguard",
  "Lidoguard Pain Relief",
  "Lidopatch",
  "LidoPro",
  "LidoPro Pain Relieving Patch",
  "LidoPro Patch",
  "Lidostat",
  "Lidotral",
  "Lidotran",
  "Lidozen",
  "Lidum",
  "Lignospan",
  "Likmez",
  "Liletta",
  "Linagliptin",
  "Lincobac",
  "Lincocin",
  "Lincomed",
  "Ling Nam Ultra Balm",
  "Linzess",
  "Liomny",
  "Lioresal",
  "Liothyronine Sodium",
  "Lipitor",
  "Lipocaine",
  "Lipofen",
  "Liq-10",
  "Liqrev",
  "LiQsorb",
  "Liquamycin",
  "Liqui-Vict 2X",
  "Liquibid",
  "Liquimat",
  "Liraglutide Saxenda",
  "Liraglutide Victoza",
  "Lisdexamfetamine Dimesylate",
  "Listerine",
  "Listerine Antiseptic",
  "Listerine Ultraclean",
  "Lite 'N Foamy",
  "Litfulo",
  "Lithium Carbonate",
  "Lithobid",
  "Lithostat",
  "Little Fevers",
  "Little Noses",
  "Little Noses Decongestant",
  "Little Ouchies",
  "Little Tummys",
  "Livalo",
  "Livdelzi",
  "Livmarli",
  "Livtencity",
  "Lixisenatide",
  "LMX",
  "Locoid",
  "Lodine",
  "Lodoco",
  "Lodosyn",
  "Lofena",
  "Lokara",
  "Lokelma",
  "LolliCaine",
  "Lomaira",
  "Lomotil",
  "Lomustine",
  "Loncor",
  "Longrange",
  "Lonhala",
  "Lonsurf",
  "Loperamide Hydrochloride",
  "Lopid",
  "Lopinavir+Ritonavir",
  "Lopressor",
  "Lopressor HCT",
  "Loprox",
  "Loqtorzi",
  "Loradamed",
  "Loratadine",
  "Lorazepam",
  "Lorbrena",
  "Lorcet",
  "Loreev",
  "Lornoxicam",
  "Lortab",
  "Lortuss EX",
  "Lorzone",
  "Losartan Potassium",
  "Losartan+Hydrochlorothiazide",
  "Lotemax",
  "Lotensin",
  "Lotensin HCT",
  "Lotrel",
  "Lotrimin",
  "Lotronex",
  "Lovaza",
  "Lovenox",
  "Loxicom",
  "Lubricant eye drops",
  "Lubrifresh P.M.",
  "Lucemyra",
  "Lucentis",
  "Luden's",
  "Luden's Drops",
  "Luden's Dual Relief",
  "Ludent",
  "Lumakras",
  "Lumicain",
  "Lumify",
  "Lumigan",
  "Lumizyme",
  "Lumoxiti",
  "Lumryz",
  "Lunesta",
  "Lunsumio",
  "Lupkynis",
  "Lupron",
  "Lurbipr",
  "Lurbiro",
  "Lustra",
  "Lutalyse",
  "Lutathera",
  "Lutrate",
  "Luxiq",
  "Luxturna",
  "Luzu",
  "Lybalvi",
  "Lydexa",
  "Lyfgenia",
  "Lyllana",
  "Lymphir",
  "Lynkuet",
  "Lynozyfic",
  "Lynparza",
  "Lypsyl",
  "Lyrica",
  "Lysine Plus",
  "Lysodren",
  "Lysteda",
  "Lytgobi",
  "Lyumjev",
  "Lyvispah",
  "M-Clear WC",
  "M-End Max D",
  "M-End PE",
  "M-M-R II",
  "Maalox Max",
  "Maalox Max Quick Dissolve",
  "Maalox Plus",
  "MacerRx",
  "Macitentan",
  "Macrobid",
  "Macrodantin",
  "Macrogols",
  "Macrosyn",
  "Macuvite with Lutein",
  "Mag 64",
  "Mag-G",
  "Mag-Ox 400",
  "Mag-Tab",
  "Maginex",
  "Magmilax",
  "MagneBind",
  "MagneBind 400 Rx",
  "Magnesium Hydroxide+Aluminium Hydroxide",
  "Magonate",
  "Magonate Reformulated May 2022",
  "Magtrate",
  "Makena",
  "Mal-A-Ket",
  "Mal-A-Ket Wipes",
  "Malacetic",
  "Malarone",
  "Malaseb",
  "Mane 'N Tail Mineral Ice",
  "Mane 'N Tail Pro-Tect",
  "Manzatin-E",
  "Mapap",
  "Mar-cof BP",
  "Mar-cof CG",
  "Maracyn",
  "Maraviroc",
  "Marboquin",
  "Marcaine",
  "Marcaine with Epinephrine",
  "Margenza",
  "Marinol",
  "Marplan",
  "Marqibo",
  "Marquis",
  "Marten-Tab",
  "Matrix",
  "Matulane",
  "Matzim",
  "Mavenclad",
  "Mavyret",
  "Maxalt",
  "Maxiclens",
  "Maxidex",
  "Maximum D3",
  "Maxiphen CDX",
  "Maxitrol",
  "MaxiVision Lutein Formula",
  "Maxzide",
  "Mayzent",
  "Mebendazole",
  "Mebeverine Hydrochloride",
  "Mecasermin",
  "MedActive Rinse",
  "Mederma Advanced Scar",
  "Mederma for Kids",
  "Mederma PM",
  "Mederma Stretch Mark Therapy",
  "Medi-Derm",
  "Medi-Derm with Lidocaine",
  "Medi-Lyte",
  "Medicaine Sting",
  "Medicasp",
  "Medicone",
  "Medicone Hemorrhoidal",
  "Mediplast",
  "Medrol",
  "Medrox",
  "Medroxyprogesterone Acetate",
  "Mefloquine",
  "Megestrol Acetate",
  "Mekinist",
  "Mektovi",
  "Melatonex",
  "Melatonin",
  "Melfiat",
  "Meloxidyl",
  "Meloxivet",
  "Melquin-3",
  "Memantine",
  "Men-phor",
  "Menactra",
  "Menest",
  "Menopur",
  "Menostar",
  "Menquadfi",
  "Mentax",
  "Menthac Arthritis Cream with Capsaicin",
  "Mentholatum",
  "Menveo",
  "Mephyton",
  "Mepolizumab",
  "Mepron",
  "Mepsevii",
  "Merilog",
  "Mesalazine (Mesalamine)",
  "Mesnex",
  "Mesterolone",
  "Mestinon",
  "Metacam",
  "Metadate",
  "Metamucil",
  "Metamucil Clear & Natural",
  "Metaxall",
  "Metformin Hydrochloride",
  "Metformin+Sitagliptin",
  "Methadose",
  "Methagual",
  "Methazolamide",
  "Methenamine Hippurate",
  "Methergine",
  "Methimazole-Thiamazole",
  "Methitest",
  "Methotrexate",
  "Methoxsalen",
  "Methsuximide",
  "Methyl Salicylate+Menthol",
  "Methyldopa",
  "Methylin",
  "Methylphenidate Hydrochloride",
  "Metoclopramide Hydrochloride",
  "Metolazone",
  "Metopirone",
  "Metoprolol",
  "Metozolv",
  "MetroCream",
  "MetroGel",
  "MetroLotion",
  "Metronidazole",
  "Metronidazole vag",
  "Metvixia",
  "Metyrapone",
  "Mexiletine Hydrochloride",
  "Mexsana",
  "MG 217 Psoriasis",
  "MG Plus Protein",
  "MG217 Psoriasis Coal Tar",
  "MG217 Psoriasis Salicylic Acid",
  "Mi-Acid Gas Relief",
  "Miacalcin",
  "Micaderm",
  "Micanol",
  "Micardis",
  "Micardis-HCT",
  "Micatin",
  "MiconaHex+Triz",
  "Miconazole Dermal",
  "Miconazole Gel",
  "Miconazole+Hydrocortisone",
  "MiCort-HC",
  "Micotil",
  "Micrell",
  "MICRhoGAM",
  "Micro-Guard",
  "Midamox",
  "Midodrine Hydrochloride",
  "Miebo",
  "Mielim Y Mas",
  "Mifeprex",
  "Migergot",
  "Migranal",
  "Milantex",
  "Milbeguard",
  "MilbeMite",
  "MILLIPRED",
  "Milnacipran",
  "Milophene",
  "Mineral ice",
  "MiniDrops",
  "Minipress",
  "Miniprin",
  "Minivelle",
  "Minocin",
  "Minocycline Hydrochloride",
  "Minolira",
  "Minoxidil",
  "Minoxidil Scalp",
  "Mintox Plus",
  "Miochol",
  "Miostat",
  "Miplyffa",
  "Mirabegron",
  "Mirafast",
  "Miralax",
  "Mirapex",
  "Mirataz",
  "Mircera",
  "Mirena",
  "Mirtazapine",
  "Mirvaso",
  "Mitigare",
  "Mitigo",
  "Mitosol",
  "Mitotane",
  "Miudella",
  "Mixed Amphethamine Salts",
  "Mnexspike 2025-2026",
  "Mobic",
  "Mobisyl",
  "Modafinil",
  "Moderiba",
  "Modeyso",
  "Modulis",
  "Moisture Eyes PM",
  "Moisturel Therapeutic",
  "MoistureWorx",
  "Molecular AF",
  "Mollifene",
  "Molnupiravir",
  "Mometamax",
  "Mometamax Single",
  "Mometasone Furoate",
  "Mometavet",
  "Mondoxyne",
  "Monistat",
  "Monistat Care",
  "Monistat Itch Relief",
  "Monistat Simple Therapy",
  "Monistat Soothing Care",
  "Monjuvi",
  "Monocal",
  "Monoclate",
  "Monodox",
  "Monoferric",
  "Monovisc",
  "Montelukast",
  "Morgidox",
  "Morning After",
  "Morphine Sulfate",
  "Mosco Corn & Callus Remover",
  "Mosco One Step Corn Remover",
  "Motazol",
  "Motegrity",
  "Motofen",
  "Motpoly",
  "Motrin",
  "Motrin PM",
  "Mounjaro",
  "Movantik",
  "Moviprep",
  "MoviPrep",
  "Movodyl",
  "Moxatag",
  "Moxifloxacin",
  "Moxifloxacin eye",
  "Moxisolv",
  "Mozobil",
  "Mresvia",
  "MS Contin",
  "MST 600",
  "MTX Support",
  "Mucilin",
  "Mucinex",
  "Mulpleta",
  "Multaq",
  "Multi-Delyn",
  "Multigen",
  "Multigen Plus",
  "Multitrace-4",
  "Multitrace-5",
  "Multrys",
  "Mupirocin",
  "Mupirocin Nasal",
  "Muricin",
  "Murine Dry Eyes",
  "Murine Ear",
  "Muro 128",
  "Muse",
  "Mutamycin",
  "Mvasi",
  "MVC-Fluoride",
  "My Choice",
  "My Way",
  "Myalept",
  "Myambutol",
  "Mycamine",
  "Mycapssa",
  "Mycinaire",
  "Mycinette Sore Throat Spray",
  "Mycitracin Plus Pain Reliever",
  "Mycobutin",
  "Mycocide NS",
  "Mycophenolate Mofetil",
  "Mydayis",
  "Mydcombi",
  "Mydfrin",
  "Mydriacyl",
  "Myfembree",
  "Myfortic",
  "Myhelper",
  "Myhibbin",
  "Myleran",
  "Mylicon",
  "Mylicon Children's",
  "Mylotarg",
  "Myobloc",
  "Myoflex",
  "MyoGesic-CS",
  "Myorisan",
  "Myqorzo",
  "Myrbetriq",
  "Mysoline",
  "Mytesi",
  "Myxredlin",
  "N Ice with Vitamin C",
  "N'ICE",
  "Na-zone",
  "Nabi-HB",
  "Nafarelin",
  "Nafrinse",
  "Naftin",
  "Naglazyme",
  "Nalfon",
  "Nalocet",
  "Namenda",
  "Namzaric",
  "Naphcon A",
  "Naprelan",
  "Naprosyn",
  "Naproxen",
  "Narcan",
  "Nardil",
  "Naropin",
  "Nasacort",
  "Nasadrops",
  "Nasalcrom",
  "Nascobal",
  "Nasonex",
  "Nasop",
  "Nasopen PE",
  "Nasopro 24",
  "Natacyn",
  "Natelle",
  "Natesto",
  "Natpara",
  "Natroba",
  "Nature-Throid",
  "Navelbine",
  "Naxcel",
  "Nayzilam",
  "NebuPent",
  "Nebusal",
  "Neffy",
  "Nembutal",
  "Nemex",
  "Nemluvio",
  "Neo-Polycin",
  "Neo-Polycin HC",
  "Neo-Predef",
  "Neo-Synalar",
  "Neo-Synephrine",
  "Neo-Synephrine 12 Hour",
  "NeoBenz Micro",
  "NeoBenz Micro Wash",
  "Neomycin Sulfate",
  "Neomycin+Dexamethasone",
  "Neoprofen",
  "NeoQ10",
  "Neoral",
  "Neova Complex HQ Plus",
  "Neovet",
  "Nerlynx",
  "Nerven herbal product",
  "Nesacaine",
  "Nesina",
  "Netupitant+Palonosetron",
  "Neuac",
  "Neulasta",
  "Neumega",
  "Neupogen",
  "Neupro",
  "Neurontin",
  "Neut brand of sodium bicarbonate",
  "Neutracare",
  "NeutraGard",
  "Neutramaxx",
  "NeutrapHor",
  "Neutraphorus Rex Skin Protectant",
  "Nevanac",
  "New Day",
  "New-Skin Liquid Bandage",
  "New-Skin Poison Ivy",
  "New-Skin Scar Fade",
  "Nexafed",
  "Nexavar",
  "Nexavir",
  "NexGard",
  "NexGard Combo",
  "NexGard Plus",
  "Nexha",
  "Nexiclon",
  "Nexium",
  "Nexletol",
  "Nexlizet",
  "Nexobrid",
  "Nexplanon",
  "Next Choice One Dose",
  "Nexterone",
  "Nexviazyme",
  "Ngenla",
  "Niacor",
  "Niaspan",
  "NicAzel",
  "Nicduic",
  "Nicoderm C-Q",
  "Nicomide",
  "Nicorelief",
  "Nicorette",
  "Nicotine",
  "NICOTINIC ACID",
  "Nicotrol",
  "Nifedipine",
  "Nifedipine+Lidocaine",
  "Niferex-150",
  "Nikita",
  "Niktimvo",
  "Nilandron",
  "Nimbex",
  "Nimodipine",
  "Nimotop",
  "Ninjacof",
  "Ninjacof A",
  "Ninjacof XG",
  "Ninlaro",
  "Nioxin",
  "Nipent",
  "Nipride",
  "Niraparib",
  "Nitazoxanide",
  "Nitro-Bid",
  "Nitro-Dur",
  "Nitrofurantoin",
  "Nitrolingual",
  "NitroMist",
  "Nitrostat",
  "Nityr",
  "Niva Thyroid",
  "Niva-Fol",
  "Nivestym",
  "Nivolumab",
  "Nix Cream Rinse",
  "Nizoral",
  "Nizoral Psoriasis",
  "No Doz",
  "Nocdurna",
  "Nocita",
  "Noctiva",
  "Nocto",
  "Nolix",
  "Nolvadent",
  "Nolvasan",
  "Norco",
  "Norditropin",
  "Norelgestromin+Ethinylestradiol",
  "Norethisterone Acetate",
  "Norfenicol",
  "Norgesic",
  "NoRisc",
  "Noritate",
  "Norliqva",
  "Normlshield",
  "Normosol-M",
  "Normosol-R",
  "Normosol-R in 5 % Dextrose",
  "Norocillin",
  "Noromectin",
  "Noromectin Plus",
  "Noromycin",
  "Norpace",
  "Norpramin",
  "Nortemp",
  "Northera",
  "Nortriptyline Hydrochloride",
  "Norvasc",
  "Norvir",
  "Norwich Aspirin",
  "Nostrilla",
  "Nouress",
  "Nourianz",
  "Novacort",
  "Novarel",
  "Novipet Joint Support",
  "Novipet Magic Bites",
  "Novoeight",
  "Novolin",
  "Novolin N",
  "Novolin R",
  "NovoLog",
  "NovoLog Mix",
  "Novoseven",
  "Novox",
  "Noxafil",
  "Noxzema Clean",
  "NP Thyroid",
  "Nplate",
  "Nu Skin Clear Action",
  "Nu-Iron 150",
  "Nubeqa",
  "Nucala",
  "Nucort",
  "Nucynta",
  "Nuedexta",
  "Nuflor",
  "Nulev",
  "Nulibry",
  "Nullo",
  "Nulojix",
  "Numbrino",
  "Numfast",
  "Numotizine",
  "Numstat",
  "NuOx",
  "Nupercainal",
  "Nuplazid",
  "Nuprin Backache",
  "Nupro Chlorhexidine",
  "Nurtec",
  "Nutralox",
  "Nutraplus",
  "Nutrilipid",
  "Nutrilyte",
  "Nutrilyte II",
  "Nutropin",
  "NuvaRing",
  "Nuvaxovid 2025-2026",
  "Nuvessa",
  "Nuvigil",
  "Nuwiq",
  "Nuzon",
  "Nuzyra",
  "Nyamyc",
  "Nydamax",
  "Nymalize",
  "Nypozi",
  "Nystatin",
  "Nystop",
  "Nytol",
  "Nyvepria",
  "Oasis Tears",
  "Obeticholic acid",
  "Obizur",
  "Obredon",
  "OC 8 Adult Acne",
  "Ocaliva",
  "Ocean Blue Nutritionals Omega-3 1450",
  "Ocean brand of sodium chloride",
  "Ocrelizumab",
  "Ocrevus",
  "Ocrevus Zunovo",
  "Octagam",
  "Ocufen",
  "Ocuflox",
  "OcuFresh",
  "Ocusan Dry Eyes",
  "Ocusoft",
  "Ocuvite",
  "Ocuvite Lutein",
  "Odactra",
  "Odefsey",
  "Odomzo",
  "Ofev",
  "Ofloxacin",
  "Ofloxacin eye drops",
  "Ogen",
  "Ogivri",
  "Ogsiveo",
  "Ohtuvayre",
  "Ojemda",
  "Ojjaara",
  "Okebo",
  "Olanzapine",
  "Olaparib",
  "Olinvyk",
  "Olpruva",
  "Olumiant",
  "Olux",
  "Omalizumab",
  "Ombitasvir+Paritaprevir+Ritonavir",
  "Omega 3 acid ethyl esters",
  "Omegaven",
  "Omeprazole",
  "Omidria",
  "Omlonti",
  "Omlyclo",
  "Omnaris",
  "Omni Gel",
  "Omnitrope",
  "Omvoh",
  "Onapgo",
  "Oncaspar",
  "Ondansetron",
  "Onexton",
  "Onfi",
  "Ongentys",
  "Onglyza",
  "Onivyde",
  "Onpattro",
  "Onsior",
  "Ontralfy",
  "Ontruzant",
  "Onureg",
  "Ony-Clear",
  "Onyda",
  "Onzetra",
  "Opcicon One-Step",
  "Opcon-A",
  "Opdivo",
  "Opdivo Qvantig",
  "Opdualag",
  "Opfolda",
  "Opipza",
  "Opsumit",
  "Opsynvi",
  "Optase",
  "Opti-Nail",
  "Opticlear",
  "Optiflex-C",
  "Optiflex-G",
  "Optigene",
  "Optima Plus",
  "Optimmune",
  "Option 2",
  "Opuviz",
  "Opvee",
  "Opzelura",
  "Ora Relief",
  "Orabase",
  "Orabloc",
  "Oracea",
  "Oracit",
  "Orajel",
  "Oralair 100",
  "Oralair 300",
  "Oralone",
  "OraMagic Plus",
  "Orapred",
  "Oraqix",
  "Orasep Reformulated Dec 2013",
  "OraVerse",
  "Oravig",
  "Orazinc",
  "Orbactiv",
  "Orbax",
  "Orencia",
  "Orenitram",
  "Orfadin",
  "Organix Complete",
  "Orgovyx",
  "Orilissa",
  "ORKAMBI",
  "Orladeyo",
  "Orlistat",
  "Orlynvah",
  "Ormalvi",
  "Oro Clense",
  "Orphengesic",
  "Orserdu",
  "Ortho-Nesic",
  "Orthovisc",
  "Ortikos",
  "Orudis",
  "Os-Cal 500 with D",
  "OsCal 500",
  "Oscimin",
  "Oscion",
  "Oseltamivir",
  "Oseni",
  "Osenvelt",
  "Osimertinib",
  "Osmitrol",
  "Osmoflex",
  "Osmolex",
  "OsmoPrep",
  "Osphena",
  "Ospomyv",
  "Osteo Bi-Flex",
  "Osteo-Poretical",
  "Ostercal-D",
  "Osticoxib",
  "OstiFen",
  "Ostilox",
  "OstiMax",
  "Osurnia",
  "Otezla",
  "Oticin HC",
  "Otiprio",
  "Otix",
  "Otodine",
  "Otomax",
  "Otovel",
  "Otrexup",
  "Otulfi",
  "Outgro Pain Relief",
  "Ovace",
  "Ovacyst",
  "Ovadine",
  "Ovamed",
  "Ovide",
  "Ovidrel",
  "Oxaliplatin",
  "Oxandrin",
  "Oxaydo",
  "Oxazepam",
  "Oxbryta",
  "Oxcarbazepine",
  "Oxervate",
  "Oxipor VHC",
  "Oxistat",
  "Oxlumo",
  "Oxtellar",
  "Oxy Deep Pore",
  "Oxy Gard",
  "Oxybutynin ",
  "Oxycide",
  "Oxycodone Hydrochloride",
  "Oxycodone+Naloxone",
  "Oxycodone+Paracetamol",
  "Oxycontin",
  "Oxytrol",
  "Oysco 500 with D",
  "Oysco D",
  "Ozanimod",
  "Ozempic",
  "Oziltus",
  "Ozobax",
  "Ozurdex",
  "P & S",
  "P-A-C Analgesic",
  "Pacerone",
  "Paclitaxel",
  "Pacnex",
  "Pad Kote",
  "Padcev",
  "Palforzia",
  "Palladia",
  "Palonosetron",
  "Palsonify",
  "Palynziq",
  "Pamelor",
  "Pamine",
  "Pamprin Cramp Formula",
  "Pamprin Max Formula",
  "Pamprin Multi-Symptom",
  "Panacur",
  "Panadol",
  "Panadol Extra",
  "Panadol PM",
  "PanaKare",
  "Pancreatin+Ox Bile Extract",
  "Pancreaze",
  "PancrePlus",
  "Pandel",
  "Panhematin",
  "Panoquell",
  "Panretin",
  "Pantoprazole",
  "Panzyga",
  "Papaverine Hydrochloride",
  "Papzimeos",
  "Paracetamol ",
  "Paracetamol+Diphenhydramine+Pseudoephedrine",
  "Paracetamol+Ibuprofen",
  "Paracetamol+Orphenadrine",
  "Paracetamol+Papaverine+Codeine+Atropine",
  "Paracetamol+Pseudoephedrine",
  "Paraffin Oil",
  "Paraffin+Lanolin",
  "ParaGard",
  "Paraplatin",
  "Parasedge Multi",
  "Paremyd",
  "Parlodel",
  "Parnate",
  "Paroex",
  "Paromomycin Sulfate",
  "Paroxetine",
  "Parsabiv",
  "Paser D/R",
  "Pataday",
  "PATANASE",
  "Pavblu",
  "Paxil",
  "Pazol XS",
  "PCxx Neutral Foam",
  "PCxx Neutral Rinse",
  "Pedia-Lax",
  "Pedia-Lax Chewable",
  "Pedia-Lax Liquid",
  "Pedia-Lax Liquid Glycerin Suppositories",
  "Pediaclear",
  "Pediaclear Childrens",
  "Pediaclear Cough",
  "Pediapred",
  "PEDIARIX",
  "Pedmark",
  "PedvaxHIB",
  "Pegasys",
  "Pegfilgrastim",
  "Peginterferon Alfa 2A",
  "Pemazyre",
  "Pembrolizumab",
  "Pemfexy",
  "Pemgarda",
  "Pemrydi Rtu",
  "Penbraya",
  "Penfluridol",
  "Penicillin V Pot, Phenoxymethylpenicillin, Penicillin VK",
  "Penmenvy",
  "Pennsaid",
  "Pentacel",
  "Pentam",
  "Pentasa",
  "Pentobarsol",
  "Pep-Back",
  "Pepcid",
  "Pepcid Complete",
  "Pepsin Comp",
  "Pepto Nausea",
  "Pepto-bismol",
  "Pepto-Bismol Children's",
  "Percocet",
  "Percogesic Backache",
  "Percogesic Reformulated Jan 2011",
  "Percorten V",
  "Percy Medicine",
  "Perdiem Overnight",
  "Perfect Choice",
  "Perform",
  "Perforomist",
  "Periciazine",
  "Peridex",
  "Perigiene",
  "PeriGuard",
  "PeriGuard Ointment",
  "Perio Med",
  "PerioChip",
  "Periogard",
  "Periostat",
  "Perjeta",
  "Permethrin",
  "Pernox Scrub Cleanser",
  "Perox-A-Mint",
  "Peroxi-Fresh",
  "Peroxy Shield",
  "Peroxyl",
  "Perphenazine",
  "Persa-Gel",
  "Perseris",
  "Pertuzumab",
  "Pertzye",
  "Pet Pectillin",
  "Pet-ema",
  "Petrem",
  "Pexeva",
  "Pfizerpen",
  "Pharbetol",
  "Phazyme",
  "Phazyme Gas & Acid",
  "Pheburane",
  "Phenadoz",
  "Phenazone+Amethocaine",
  "Phenazopyridine Hydrochloride",
  "Pheneen",
  "Phenelzine Sulphate",
  "Phenergan",
  "Phenobarbital, Phenobarbitone",
  "Phenohytro",
  "Phenoxybenzamine",
  "Phentermine",
  "Phenylephrine Hydrochloride eye",
  "Phenylpro",
  "Phenytek",
  "Phenytoin",
  "Phesgo",
  "Phexx",
  "Phexxi",
  "Phillips Milk of Magnesia",
  "Phillips Stool Softener",
  "Phillips' Cramp-free",
  "Phisoderm Clear Confidence Body Wash",
  "Phisoderm Clear Confidence Daily Gel Face Wash",
  "Phisoderm Clear Confidence Spot Treatment",
  "Phos-Flur",
  "Phoslo",
  "Phoslyra",
  "Phospha 250 Neutral",
  "Phosphasal",
  "Phosphates Comp (Rectal)",
  "Phospholine Iodide",
  "Photofrin",
  "Photrexa",
  "Phyrago",
  "Physiolyte",
  "Physiosol",
  "Piasky",
  "Pico-Salax",
  "Picot",
  "Pifeltro",
  "Pileran",
  "Pilocar",
  "Pimecrolimus",
  "Pimozide",
  "Piqray",
  "Pirnuo",
  "Piroxicam",
  "Piroxicam as Beta-Cyclodextrin",
  "Pitocin",
  "Pivya",
  "Placadine",
  "Plan B One-Step",
  "Plaquenil",
  "Plasbumin",
  "Plasma-lyte 148",
  "Plasma-Lyte 56 in 5 % Dextrose",
  "Plasmalyte A",
  "Plasmanate",
  "Plavix",
  "Plegridy",
  "Plenamine",
  "Plexion",
  "Pliaglis",
  "Pluset",
  "Pluvicto",
  "Pneumovax 23",
  "Podocon",
  "Podophyllotoxin",
  "Pokonza",
  "Polar Freeze",
  "Polar Frost",
  "Polivy",
  "Polocaine",
  "Poly Hist PD",
  "Poly Iron 150 Forte",
  "Poly-Dex",
  "Poly-Vi-Sol",
  "Poly-Vi-Sol with Iron",
  "Polycin",
  "Polyethylene Glycol",
  "Polyflex",
  "Polymyxin+Neomycin+Dexamethasone",
  "Polysporin",
  "Polytrim",
  "Pomalyst",
  "Pombiliti",
  "Ponatinib",
  "Pontocaine",
  "Ponvory",
  "Portrazza",
  "Posaconazole",
  "Posatex",
  "Posfrea",
  "Posimir",
  "PostDay One-Step",
  "Potaba",
  "Potassium and sodium phosphates",
  "Potassium Chloride",
  "Potassium Citrate",
  "Potassium gluconate",
  "Poteligeo",
  "Povidone",
  "Povidone Iodine",
  "Pradalex",
  "Pradaxa",
  "Praluent",
  "PrameGel Reformulated Apr 2012",
  "Pramosone",
  "Prandin",
  "Prascend",
  "Prasugrel",
  "Pravachol",
  "Pravastatin",
  "Prax",
  "Praxbind",
  "Prazimectin",
  "Praziquantel",
  "Precedex",
  "Precose",
  "Pred Forte",
  "Pred Mild",
  "Pred-G",
  "Prednisolone",
  "Prednisolone Acetate",
  "Prednisolone+Gentamicin",
  "Prednisone",
  "Prednistab",
  "Pregabalin",
  "Pregnitude",
  "Pregnyl",
  "Prehevbrio",
  "Prelief",
  "Premarin",
  "PremaSol",
  "Premsyn PMS",
  "Prepidil",
  "PreserVision",
  "PreserVision with Lutein",
  "Prestalia",
  "Pretz",
  "Prevacid",
  "Prevail Injectable",
  "Prevalite",
  "Prevantics",
  "Prevduo",
  "Preventeza",
  "Previcox",
  "Prevident",
  "Prevident 5000 Sensitive",
  "Prevident Dental Rinse",
  "Prevnar 13",
  "Prevnar 20",
  "Prevymis",
  "Prezcobix",
  "Prezista",
  "Prialt",
  "Pributazone",
  "Priftin",
  "Prilosec",
  "Primacur",
  "Primaquine Phosphate",
  "Primatene Mist Inhaler",
  "Primatene with ephedrine",
  "Primatene with ephedrine & guaifenesin",
  "Primaxin",
  "Primeguard",
  "Primidone",
  "Primlev",
  "Primsol",
  "Prinivil",
  "Priorix",
  "Pristiq",
  "Pritox",
  "Privermectin",
  "Privigen",
  "Privine",
  "ProAir",
  "Probanthine",
  "Probenecid",
  "ProcalAmine 3",
  "Procarbazine",
  "Procardia",
  "ProCentra",
  "Proclearz",
  "ProCoMycin",
  "Procort 1.85/1.15",
  "Procrit",
  "Procto-Kit",
  "Procto-Med",
  "Procto-Pak",
  "Proctocort",
  "Proctofoam",
  "Proctofoam-HC",
  "Proctosol",
  "Proctozone HC",
  "Procyclidine Hydrochloride",
  "Procysbi",
  "ProDenRx Rinse",
  "Prodium",
  "Profender",
  "Proferrin",
  "Profilnine",
  "Progesterone Inj",
  "Progesterone micronized cap",
  "Progesterone vag tab",
  "Proglycem",
  "Prograf",
  "Proheart",
  "Proheart 6",
  "Proin",
  "Prolastin",
  "Prolate",
  "Prolaxa",
  "Prolensa",
  "Proleukin",
  "Prolia",
  "PROMACE",
  "Promacta",
  "Promectin",
  "Promethazine",
  "Promethegan",
  "Prometrium",
  "Promolaxin",
  "Pronto",
  "Pronto Plus",
  "Pronto Plus Lice Egg Remover",
  "Propa P.H.",
  "Propa P.H. Acne Mask",
  "Propafenone Hydrochloride",
  "Propecia",
  "Propel",
  "Propoflo",
  "Propovan",
  "Propoven",
  "Propranolol Hydrochloride",
  "Proprinal",
  "Propylthiouracil",
  "ProQuad",
  "Proquin",
  "Proscar",
  "Prosed DS",
  "Prosol",
  "Prostamate",
  "Prostin VR",
  "Protonix",
  "Protopam",
  "Protopic",
  "Provayblue",
  "Provenge",
  "Proventil",
  "Provera",
  "Provigil",
  "Provisc",
  "Provita Combat",
  "Prozac",
  "ProZinc",
  "Prudoxin",
  "Pseudoephedrine Hydrochloride",
  "Pseudoephedrine+Dextromethorphan+Paracetamol",
  "Pseudoephedrine+Loratadine",
  "Psorcon",
  "Psoriasin",
  "Psoriasin Wash",
  "Pulmicort",
  "PulmoSal",
  "Pulmozyme",
  "Pur-Oxy",
  "Pur-Wash",
  "PureLax",
  "Purixan",
  "Purklenz",
  "Puroxcin",
  "Pylera",
  "Pyquvi",
  "Pyramax",
  "Pyrantel Pamoate",
  "Pyrazinamide",
  "Pyridium",
  "Pyridostigmine Bromide",
  "Pyridoxine+B12+Thiamine",
  "Pyrimethamine",
  "Pyrukynd",
  "Pyzchiva",
  "Q-Fed",
  "Q-Gel",
  "Q-Gel with Lipoic Acid",
  "Q-Sorb Co Q-10",
  "Q-Up",
  "Qalsody",
  "Qamzova",
  "Qbrelis",
  "Qbrexza",
  "Qdolo",
  "Qelbree",
  "Qfitlia",
  "Qinlock",
  "Qivigy",
  "Qlearquil Nasal Decongestant",
  "Qlosi",
  "Qmiiz",
  "Qnasl",
  "Qsymia",
  "Qtern",
  "Quadracel",
  "Quadramet",
  "Qualaquin",
  "Quarter Mate",
  "Quartermaster",
  "QuarterMate Concentrate",
  "Qudexy",
  "Quelicin",
  "Quellaxcin",
  "Quellin",
  "Quest Plus",
  "Questran",
  "Quetiapine",
  "QuilliChew",
  "Quillivant",
  "Quinagolide",
  "Quinidine",
  "Quinja",
  "QuinZyme",
  "Quiofic",
  "Qulipta",
  "Qutenza",
  "Quviviq",
  "Quzyttir",
  "Qvar",
  "Qwo",
  "R A Acne",
  "RabAvert",
  "RadiaGuard",
  "Radicava",
  "Radiogardase",
  "Ragwitek",
  "Raldesy",
  "Ralgro",
  "Raloxifene Hydrochloride",
  "Ramipril",
  "Ramipril+Hydrochlorothiazide",
  "Ranexa",
  "Rapaflo",
  "Rapamune",
  "Rapiblyk",
  "Rapivab",
  "Raplixa",
  "Rasagiline",
  "Rash Relief Antibacterial",
  "Rash Relief Antifungal",
  "Rash Relief Clear",
  "Rash Relief with Zinc Oxide",
  "Rasuvo",
  "Ravicti",
  "Ravulizumab",
  "Rayaldee",
  "Rayasal",
  "Rayos",
  "Razadyne",
  "Re-Covr",
  "Rea Lo 39",
  "Rea-Lo",
  "React",
  "ReadyBath",
  "Rebalance",
  "Rebif",
  "Rebinyn",
  "Reblozyl",
  "Reboxetine",
  "Rebyota",
  "Recarbrio",
  "Reclast",
  "Recombinate",
  "Recombivax",
  "RECONCILE",
  "Recorlev",
  "Recort Plus",
  "Recothrom",
  "Recticare",
  "RectiCare Advance Cream",
  "Recticare Wipes",
  "Rectiv",
  "Red Cross Canker Sore",
  "Red Hot",
  "Redemplo",
  "Rederox",
  "Reditrex",
  "Redutemp",
  "Refenesen",
  "Refissa",
  "Regenecare",
  "Regener-Eyes",
  "Regiocit",
  "Reglan",
  "Regonol",
  "Regoxidine",
  "Regranex",
  "Regu-Mate",
  "Reguloid",
  "Relador",
  "Relafen",
  "Relagard",
  "Relagesic",
  "Relenza",
  "Releuko",
  "Relexxii",
  "ReliOn Glucose",
  "Relistor",
  "Relovox",
  "Relpax",
  "Reltone",
  "Relyvrio",
  "Remain Gold",
  "Remergent HQ",
  "Remeron",
  "Remeven",
  "Remicade",
  "Remodulin",
  "Rena-Vite",
  "Renacidin",
  "RenaGel",
  "RenaKare",
  "Renaplus",
  "Renflexis",
  "Renova",
  "Renthyroid",
  "Renvela",
  "Repaglinide",
  "Repan",
  "Repatha",
  "Rephresh Pro-B",
  "Replesta NX",
  "Reprexain",
  "Requip",
  "Resflor",
  "Resinol",
  "Reslizumab",
  "Respa-BR",
  "Respirmycin",
  "Rest Simply",
  "Restart",
  "Restasis",
  "Restone",
  "Restoril",
  "Retacrit",
  "Retavase",
  "Retevmo",
  "Rethymic",
  "Retin-A",
  "Retisert",
  "Retrovir",
  "Revalor",
  "Revatio",
  "Revcovi",
  "Revertased",
  "Revertidine",
  "ReVia",
  "Revitaderm Psoriasis",
  "RevitaDERM Wound Care",
  "Revlimid",
  "Revolt",
  "Revolution",
  "Revolution Plus",
  "Revonto",
  "Revuforj",
  "Rextovy",
  "Rexulti",
  "Reyataz",
  "Reyvow",
  "Rezamid",
  "Rezdiffra",
  "Rezenopy",
  "Rezipres",
  "Rezlidhia",
  "Rezurock",
  "Rezvoglar",
  "Rezyst Probiotic",
  "Rezzayo",
  "RFD",
  "Rhapsido",
  "Rhinall",
  "Rhinaris",
  "Rhinocort",
  "Rhinomel",
  "Rhofade",
  "RhoGAM",
  "Rhophylac",
  "Rhopressa",
  "Rhuli",
  "Ri-Mag Plus",
  "Riabni",
  "RiaSTAP",
  "Riax",
  "Ribasphere",
  "RibaTab",
  "Ribavirin",
  "Ricola",
  "RID",
  "Ridaura",
  "Rifadin",
  "Rifampicin, Rifampin",
  "Rifaximin",
  "Rilexine",
  "Rilutek",
  "Riluzole",
  "Rimadyl",
  "Rimso-50",
  "Ringl",
  "Rinvoq",
  "Riomet",
  "Risamine",
  "Risedronate Sodium",
  "Risperdal",
  "Risperidone",
  "Ritalin",
  "Ritlecitinib",
  "Ritonavir",
  "Ritonavir+Nirmatrelvir",
  "Rituxan",
  "Rituxan Hycela",
  "Rituximab",
  "Rivaroxaban",
  "Rivastigmine",
  "Rivfloza",
  "Rixubis",
  "Rizafilm",
  "Rizatriptan",
  "Robafen",
  "Robafen Cough",
  "Robaxin",
  "Robinul",
  "Rocainol",
  "Rocaltrol",
  "Rocklatan",
  "Roctavian",
  "Roflumilast ",
  "Rogaine",
  "Rogaine Anti-Dandruff",
  "Rolaids Reformulated Aug 2006",
  "Rolvedon",
  "Romosozumab",
  "Rompe Pecho",
  "Rompun",
  "Romvimza",
  "Ropinirole",
  "Rosadan",
  "Rosanil",
  "Rosula",
  "Rosuvastatin",
  "Roszet",
  "Rotarix",
  "RotaTeq",
  "Rovera",
  "Rowasa",
  "Roweepra",
  "Roxicodone",
  "Roxithromycin",
  "Roxybond",
  "Rozerem",
  "Rozlytrek",
  "Rubraca",
  "Rucaparib",
  "Ruconest",
  "Rufinamide",
  "Rukobia",
  "Ruxience",
  "Ryaltris",
  "Ryanodex",
  "Rybelsus",
  "Rybrevant",
  "Rybrevant Faspro",
  "Ryclora",
  "Rydapt",
  "Rykindo",
  "Rylaze",
  "Ryoncil",
  "Ryplazim",
  "Rystiggo",
  "Rytary",
  "Rytelo",
  "Rythmol",
  "Ryvent",
  "Ryzneuta",
  "Ryzumvi",
  "S-2",
  "Sabril",
  "Sacubitril+Valsartan",
  "Safe-Guard",
  "Safeguard Antibacterial Foaming",
  "Saizen",
  "Sajazir",
  "Sal-Plant Gel",
  "Salacyn",
  "Salagen",
  "Salbutamol",
  "Saleto",
  "Salicor",
  "Salicylic Acid",
  "Salinocaine",
  "Salivasure",
  "Salix - substance",
  "Saljet",
  "Salmeterol+Fluticasone",
  "SaltAire",
  "Salvax",
  "Salycim",
  "Salyntra",
  "Samsca",
  "Samson 8",
  "Sancuso",
  "Sandimmune",
  "Sandostatin",
  "Sani-Supp",
  "Santyl",
  "Saphnelo",
  "Saphris",
  "Sarapin",
  "Sarclisa",
  "Sarnol-HC",
  "Satogesic Hot",
  "Savaysa",
  "Savella",
  "Saxenda",
  "Sayman Salve",
  "Scalacort",
  "Scalpicin Itch Relief",
  "Scalpicin Scalp Relief",
  "Scandonest",
  "Scemblix",
  "Scenesse",
  "Schiff",
  "Sclerosol",
  "Scopolamine, Hyoscine",
  "Scot-Tussin",
  "Scot-Tussin Allergy",
  "Scot-tussin Diabetic CF",
  "Scot-Tussin DM Cough Chasers",
  "Scrub-Stat",
  "Scytera",
  "Sdamlo",
  "Sea Soft",
  "Sebasorb",
  "Sebex",
  "Sebobalance",
  "Sebulex",
  "Secuado",
  "Secukinumab",
  "Sed-Max",
  "Sedexodine",
  "Seglentis",
  "Segluromet",
  "Selarid",
  "Selarsdi",
  "Selaspot",
  "Selegiline Hydrochloride",
  "Selenium Sulfide",
  "Selexipag",
  "SelRx",
  "Selsun Blue",
  "Selsun Blue Naturals",
  "Selsun Blue Sensitive Scalp",
  "Selzentry",
  "Semaglutide Ozempic",
  "Semaglutide Rybelsus",
  "Semaglutide Wegovy",
  "Semglee",
  "Semintra",
  "Senergy",
  "Senexon",
  "Senexon S",
  "Senna comp",
  "Senna-Relief Childs",
  "Senna-Time",
  "Senna+Ispaghula",
  "Senokot",
  "SENOKOT-S",
  "SenoSol",
  "SenoSol-SS",
  "Sensipar",
  "Sensorcaine",
  "Sensorcaine with Epinephrine",
  "Sentinel Flavor Tabs",
  "Sentinel Spectrum",
  "Sentry HC Worm X DS",
  "Sentry HC Worm X Plus",
  "Senvelgo",
  "Sephience",
  "Septocaine",
  "Serevent",
  "Sernivo",
  "Seromycin",
  "Seroquel",
  "Serostim",
  "Sertraline",
  "Servo Stat Bac",
  "Sevelamer",
  "Sevenfact",
  "SevoFlo",
  "Sevospire",
  "Seysara",
  "Sezaby",
  "Shewise",
  "Shing-Releev",
  "Shingrix",
  "Signifor",
  "Siklos",
  "Siladryl",
  "Sildenafil",
  "Sildenafil-PAH",
  "Silenor",
  "Sileo",
  "Siliq",
  "Silka Cream",
  "Silka Powder",
  "Siltussin",
  "Silvadene",
  "Silver Sulfadiazine",
  "Simbadol",
  "Simbrinza",
  "Simethicone",
  "Simlandi",
  "Simparica",
  "Simparica TRIO",
  "Simplera",
  "Simplicef",
  "Simply Saline",
  "Simply Sleep",
  "Simponi",
  "Simulect",
  "Simvastatin",
  "Sinemet",
  "Sinex Long-Acting",
  "Singulair",
  "Sinucleanse",
  "Sinufrin Plus",
  "Sinuva",
  "Sirturo",
  "Sitagliptin",
  "Sitavig",
  "Sivextro",
  "Skelaxin",
  "Skin-Lube",
  "Skinmedica Purifying Foaming Wash",
  "Sklice",
  "Skyclarys",
  "Skyla",
  "Skyrizi",
  "Skysona",
  "Skytrofa",
  "Sleep-Eze",
  "Sleepinal",
  "Slo-Niacin",
  "Sloan's Liniment",
  "Slow-Fe",
  "Slow-Mag Reformulated Feb 2012",
  "Snap Labs",
  "Soaanz",
  "Sodium Acid Phosphates Comp",
  "Sodium alginate, bicarbonate and calcium carbonate",
  "Sodium Chloride Ophtalmic Solution 5%",
  "Sodium Clodronate",
  "Sodium Cromoglycate eye, Cromolyn Sodium",
  "Sodium Fusidate",
  "Sodium Polystyrene Sulfonate",
  "Sofdra",
  "Sofosbuvir",
  "Sofosbuvir+Velpatasvir",
  "Soft-Tuch",
  "Softsoap Antibacterial",
  "Sogroya",
  "Sohonos",
  "Sojourn",
  "Solaraze",
  "Solarcaine",
  "Solarcaine Plus Aloe",
  "Solensia",
  "Solifenacin",
  "Soliqua",
  "Soliris",
  "Solodyn",
  "Solosec",
  "Solovecin",
  "Soltamox",
  "Solu-Cortef",
  "Solu-Medrol",
  "Soluclenz",
  "Soluprep",
  "Soma",
  "Somatrogon",
  "Somatropin",
  "Somatuline",
  "Somavert",
  "SOMBRA Warm Pain Relieving Gel",
  "Sominex",
  "Somnapure",
  "Somnicin",
  "Sonacaine",
  "Soolantra",
  "Soothe & Cool Moisture Barrier",
  "Soothe & Cool Powder",
  "Soothe & Cool Skin Paste",
  "Soothe Lubricant Eye Drops",
  "Soothe Mineral Oil",
  "Soothe Night Time",
  "Sore No More",
  "Soriatane",
  "Sorilux",
  "Sorine",
  "Sotalol Hydrochloride",
  "Sotradecol",
  "Sotret",
  "Sotyktu",
  "Sotylize",
  "Sovaldi",
  "Sovuna",
  "SpectoGard",
  "Spectracef",
  "Spectramast",
  "Spectrocin Plus",
  "Spevigo",
  "Spherusol",
  "Spikevax",
  "Spikevax 2023-2024",
  "Spikevax 2024-2025",
  "Spikevax 2025-2026",
  "Spinraza",
  "Spiriva",
  "Spironolactone",
  "Sporanox",
  "Sporimune",
  "Sportscreme",
  "Spravato",
  "Spritam",
  "Sprix",
  "Sprycel",
  "SPS",
  "SSD",
  "SSKI brand of Potassium Iodide",
  "ST-37",
  "St. Ives Blemish & Blackhead Control",
  "St. John Wort, Hypericum",
  "St. Joseph Aspirin",
  "Stahist AD",
  "Stalevo",
  "Stamaril",
  "Stanback Headache Powder Reformulated Jan 2011",
  "Stangard",
  "StaphAseptic",
  "Starjemza",
  "Statuss Green Reformulated Jan 2012",
  "Staxyn",
  "Steglatro",
  "Steglujan",
  "Stelara",
  "Stendra",
  "Steqeyma",
  "Steritalc",
  "Stimate",
  "Stimufend",
  "Sting-Kill",
  "StingX",
  "Stiolto",
  "Stivarga",
  "Stoboclo",
  "Stomodine F",
  "Stopain",
  "Stratagraft",
  "Strattera",
  "Strensiq",
  "Stri-Dex",
  "Stri-Dex Clear Gel",
  "Stribild",
  "Stridex",
  "Striverdi",
  "Stromectol",
  "Strongid",
  "Stye",
  "Stye Soothing Relief",
  "Styptstix",
  "Suavear",
  "Sublocade",
  "Suboxone",
  "Subsys",
  "Subvenite",
  "Sucraid",
  "Sucrets",
  "Sucrets Complete",
  "Sucrets Original",
  "Sucrets Sore Throat",
  "Sudafed",
  "Sudafed OM",
  "Sudafed PE",
  "Sudo-Tab",
  "Sudogest",
  "Sudogest PE",
  "Sular",
  "Sulfadiazine",
  "Sulfamed",
  "Sulfamylon",
  "Sulfasalazine",
  "Sulfatrim",
  "Sulfo-Lo",
  "Sulfoam",
  "Sulpho-Lac",
  "Sulpiride",
  "Sumadan Wash",
  "Sumatriptan",
  "Sumaxin",
  "Summer's Eve Medicated",
  "Summers Eve Anti-Itch",
  "Sunlenca",
  "Sunosi",
  "Supartz",
  "Super Spot Remover",
  "Supprelin",
  "Supraderm",
  "Suprane",
  "Suprax",
  "Suprelorin",
  "Supreme",
  "Sure Shot 2X",
  "Surfak Stool Softener",
  "Surfaxin",
  "Surolan",
  "Surpass Anti-Inflammatory",
  "Survanta",
  "Sustain",
  "Sustiva",
  "Sustol",
  "Susvimo",
  "Sutab",
  "Sutent",
  "Sutimlimab",
  "SwineAid",
  "Swinemate",
  "Swiss Kriss",
  "Syfovre",
  "Sylvant",
  "Symax",
  "Symbicort",
  "Symbravo",
  "Symbyax",
  "Symfi",
  "Symjepi",
  "Symlin",
  "Sympazan",
  "Symproic",
  "Symtuza",
  "Symvess",
  "Synagis",
  "Synalar",
  "Synanthic",
  "Synarel",
  "Synchsure",
  "Syndros",
  "Synera",
  "Synjardy",
  "Synotic",
  "Synovex",
  "Synovex C",
  "Synovex H",
  "Synovex S",
  "Synribo",
  "Synthroid",
  "Synvisc",
  "Syprine",
  "T8 Keto Flush",
  "Tabloid",
  "Tabrecta",
  "TachoSil",
  "Taclonex",
  "Tacrolimus",
  "Tacrolimus Dermal",
  "Tacrolimus Susp",
  "Tact",
  "Tactinal",
  "Tadalafil",
  "Tadalafil Pulmonary HTN",
  "Tadliq",
  "Tafamidis",
  "Tafamidis Meglumine",
  "Tafinlar",
  "Tagamet",
  "Tagrisso",
  "Take Action",
  "Takhzyro",
  "Talicia",
  "Taltz",
  "Talvey",
  "Talzenna",
  "Tamiflu",
  "Tamoxifen Citrate",
  "Tamsulosin Hydrochloride",
  "Tanac Liquid",
  "TANDEM",
  "Tandem F",
  "Tandem Plus",
  "Tanlor",
  "Tannic-12 S",
  "Tanovea",
  "Tarceva",
  "Targadox",
  "Targretin",
  "Tarpeyo",
  "Tarsum Reformulated",
  "Tascenso",
  "Tasigna",
  "Tasmar",
  "Tauramox",
  "Tavalisse",
  "Tavist",
  "Tavist Non-Sedating",
  "Tavneos",
  "Tazicef",
  "Tazorac",
  "Taztia",
  "Tazverik",
  "Tdvax",
  "Tears Naturale Forte",
  "Tears Naturale PM",
  "Teat Dip-HP10",
  "Teat-Glo",
  "Tecartus",
  "Tecelra",
  "Tecentriq",
  "Tecentriq Hybreza",
  "Tecfidera",
  "Tecvayli",
  "Teduglutide",
  "Teflaro",
  "Teglutik",
  "Tegretol",
  "Tegrin-LT Shampoo",
  "Tegsedi",
  "Teicoplanin",
  "Tekral",
  "Tekturna",
  "Tekturna HCT",
  "Telazol",
  "Temaril-P",
  "Tembexa",
  "Temixys",
  "Temodar",
  "Temovate",
  "Temozolomide",
  "Tempra Quicklets",
  "Tencon",
  "Tenivac",
  "Tenofovir Disoproxil",
  "Tenofovir Disoproxil Fumarate+Emtricitabine",
  "Tenoretic",
  "Tenormin",
  "Tenotryl",
  "Tenuate",
  "Tepadina",
  "Tepezza",
  "Tepmetko",
  "Tepylute",
  "Terazosin",
  "Terbinafine Hydrochloride",
  "Terbinafine skin",
  "Terbutaline Sulphate",
  "Teriflunomide",
  "Teriparatide",
  "Terlivaz",
  "Terra-Vet",
  "Terramycin",
  "Terrell",
  "Tersi Foam",
  "Tessalon Perles",
  "Testim",
  "Testopel",
  "Tetcaine",
  "Tetrabenazine",
  "Tetracycline Hydrochloride ",
  "Tetrahydrozoline Hydrochloride",
  "Tetterine",
  "Tevimbra",
  "Texacort",
  "Tezacaftor+Ivacaftor, Ivacaftor ",
  "Tezepelumab",
  "Tezruly",
  "Tezspire",
  "Thalitone",
  "Thalomid",
  "The Itch Eraser",
  "The Magic Bullet",
  "Theo-24",
  "Thera-D",
  "Thera-Gesic",
  "Thera-Gesic Plus",
  "Therabloat",
  "Theramycin",
  "Theraplex Z",
  "TheraSeal Hand Protection",
  "Therastat",
  "TheraTears",
  "Thermazene",
  "Thermotabs",
  "Thiamine Hydrochloride - Vitamin B1",
  "Thianil",
  "Thioguanine",
  "Thiola",
  "Thioridazine Hydrochloride",
  "Thoracol",
  "Thrive",
  "Thrombate III",
  "Thrombin-JMI",
  "ThrushTox",
  "Thylox",
  "Thymoglobulin",
  "Thyquidity",
  "Thyro-Tabs",
  "Thyrocryn",
  "Thyrogen",
  "ThyroKare",
  "Thyrolar",
  "ThyroSafe",
  "ThyroShield",
  "Thyrotropin",
  "Tiadylt",
  "Tiapride Hydrochloride",
  "Tiazac",
  "Tibolone",
  "Tibsovo",
  "Ticagrelor",
  "Tice BCG",
  "Ticovac",
  "Tigan",
  "Tiglutik",
  "Tikosyn",
  "Timolol Maleate",
  "Timolol+Bimatoprost",
  "Timolol+Brinzolamide",
  "Timoptic",
  "Tinactin",
  "Tinaderm",
  "Tindamax",
  "Tineacide Antifungal",
  "Tinidazole",
  "Tiopronin",
  "Tiotropium",
  "Tiotropium+Olodaterol",
  "Tirosint",
  "Tirzepatide",
  "Tis-U-Sol",
  "Tisseel",
  "Titralac",
  "Titralac Plus",
  "Tivdak",
  "Tivicay",
  "Tivorbex",
  "Tlando",
  "Tnkase",
  "Tobi",
  "Tobradex",
  "Tobramycin Eye",
  "Tobrex",
  "Tocilizumab",
  "Today",
  "Tofacitinib",
  "Tofidence",
  "Tolak",
  "Tolcylen",
  "Tolectin 600",
  "Tolnaftate",
  "Tolsura",
  "Tolterodine",
  "Toltramax",
  "Tomorrow",
  "Tonmya",
  "TootSweet",
  "Topamax",
  "Topicaine",
  "Topicale",
  "Topicort",
  "Topiramate",
  "Toposar",
  "Toprol",
  "Torbugesic",
  "Torisel",
  "Torpenz",
  "Torphadine",
  "Tosymra",
  "Totect",
  "Toujeo",
  "Tovet",
  "Toviaz",
  "Tpoxx",
  "Trabectedin",
  "Tracleer",
  "Tradjenta",
  "Tralement",
  "Tramadol Hydrochloride",
  "Tramadol+Paracetamol",
  "Trametinib",
  "Trandate",
  "Transanosil",
  "Transderm Scop",
  "Tranxene",
  "Tranzarel",
  "Trastuzumab",
  "Trastuzumab+Emtansine",
  "Travasol 10",
  "Travatan",
  "Trazimera",
  "Trazodone Hydrochloride",
  "Treanda",
  "Trecator",
  "Trelegy",
  "Trelstar",
  "Tremelimumab",
  "Tremfya",
  "Tresaderm",
  "Tresiba",
  "Tretin X",
  "Tretinoin cap",
  "Tretinoin topical",
  "Tretten",
  "Trexall",
  "Treximet",
  "Trezix",
  "Tri Biozene",
  "Tri-Chlor",
  "Tri-Heart Plus",
  "Tri-Luma",
  "Tri-Vi-Sol",
  "Triamcinolone",
  "Triamcinolone Acetonide",
  "Triamcinolone Acetonide nasal",
  "Triamcinolone+Gramicidine+Nystatin+Neomycin",
  "Triamcinolone+Lidocaine ",
  "Trianex",
  "Triaz",
  "Tribenzor",
  "Tricalm",
  "Trichlor Fresh Pak",
  "Tricor",
  "Tricylate",
  "Tridacaine",
  "Tridergel",
  "Triderm",
  "Tridesilon",
  "Trientine",
  "Triesence",
  "Trifena",
  "Triferic",
  "Trifexis",
  "Trifluoperazine",
  "Trihexyphenidyl HCL",
  "Trijardy",
  "Trileptal",
  "Trilipix",
  "Triluron",
  "TriLyte",
  "Trimazole",
  "Trimo San",
  "Trimox",
  "Trintellix",
  "Triostat",
  "Tripenicol",
  "Triple Paste",
  "Triple Paste AF",
  "Triple Wormer",
  "Triptodur",
  "TripTone",
  "Triptorelin",
  "Trisenox",
  "Tritocin",
  "Tritolnacide",
  "Triumeq",
  "Triumph",
  "Trivisc",
  "Trizivir",
  "Trodelvy",
  "Trogarzo",
  "Trokendi",
  "Trolamine",
  "Tronolane Anesthetic",
  "Trophamine 10 %",
  "Trophamine 6 %",
  "Trospium Chloride",
  "Tru-Blu C-Hex 110",
  "Tru-Blu Chlor Hex-Wash",
  "Tru-micin",
  "Trudhesa",
  "Trulance",
  "Trulicity",
  "Trumenba",
  "Truprofen",
  "Truqap",
  "Truseltiq",
  "Trusopt",
  "Truvada",
  "Truxima",
  "Tryngolza",
  "Tryptyr",
  "Tryvio",
  "Tubersol",
  "Tucks",
  "Tudorza",
  "Tukysa",
  "Tulieve",
  "Tulissin",
  "Tums",
  "Tums Dual Action",
  "Tums with Gas Relief",
  "Turalio",
  "Tussigon",
  "Tussionex",
  "Tuxarin",
  "Tuzistra",
  "Twilite",
  "Twinrix",
  "Twirla",
  "Twyneo",
  "Twynsta",
  "Tybost",
  "Tycolene",
  "Tyenne",
  "Tygacil",
  "Tykerb",
  "Tylan",
  "Tylenol",
  "Tylenol Gelcap Extra Strength",
  "Tylenol PM",
  "Tylenol with Codeine",
  "Tymlos",
  "Typhim VI",
  "Tyruko",
  "Tyrvaya",
  "Tysabri",
  "Tyvaso",
  "Tyzavan",
  "Tzed",
  "Tzield",
  "U-Cort",
  "U-Kera",
  "U-Lactin",
  "Uber Numb",
  "Ubrelvy",
  "Uceris",
  "UdderBlend",
  "Udderdine",
  "Udenyca",
  "Ulcerease",
  "UlcerGard",
  "Ulesfia",
  "Ulipristal Acetate",
  "Uloric",
  "Ulspira",
  "Ultacan",
  "Ultane",
  "Ultiva",
  "Ultomiris",
  "Ultra Mide",
  "Ultracet",
  "Ultram",
  "Ultrasal",
  "Ultravate",
  "Umbrellin",
  "Umeclidinium",
  "Umeclidinium+Vilanterol",
  "Umecta",
  "Unasyn",
  "Unburn",
  "Undecatrex",
  "Unguentine",
  "Unguentine Maximum Strength",
  "Uni Salve",
  "Uniferon",
  "Unifiber",
  "Uniprim",
  "Unisom",
  "Unisom Sleep",
  "Unisom with Pain Relief",
  "Unithroid",
  "Unituxin",
  "Unloxcyt",
  "Upcard",
  "Uplizna",
  "Upneeq",
  "Uptravi",
  "Uramaxin",
  "Urea+Lactic Acid",
  "Ureacin-10",
  "Ureacin-20",
  "Urelle",
  "Uretron DS",
  "Urex",
  "Uribel",
  "Uribel Tabs",
  "Uricalm",
  "Urimar Reformulated Oct 2013",
  "Urin DS",
  "Uripropamine",
  "Uristat",
  "Uro-Blue",
  "Uro-Mag",
  "Urocit-K",
  "Urogesic Blue Reformulated Apr 2012",
  "Uroqid-Acid No.2",
  "UroXatral",
  "Urso",
  "Urso Forte",
  "Ursodeoxycholic Acid",
  "Ustekinumab",
  "Ustell",
  "Utira",
  "Utopic",
  "Uvadex",
  "Uzedy",
  "Vabomere",
  "Vabrinty",
  "Vabysmo",
  "Vacasan",
  "Vafseo",
  "Vagifem",
  "Vagisil Original Formula",
  "Vagisil Satin",
  "Vagisil Wipes",
  "Vagistat",
  "Vagistat-1",
  "Valbazen",
  "Valchlor",
  "Valcor",
  "Valcyte",
  "Valerian",
  "Valerian+Passiflora",
  "Valganciclovir",
  "Valiant Barrier",
  "Valiant Shield",
  "Valium",
  "Valproic Acid, Sodium Valproate",
  "Valsartan",
  "Valsartan+Hydrochlorothiazide",
  "Valstar",
  "Valtoco",
  "Valtrex",
  "Vanacof AC",
  "Vanadom",
  "Vanalice",
  "Vanamine",
  "Vanatol",
  "Vancocin",
  "Vandazole",
  "Vanflyta",
  "Vanicream Diaper Rash",
  "Vanos",
  "Vanoxide-HC",
  "Vanquish",
  "Vanrafia",
  "Vaporex",
  "Vaprisol",
  "Vaqta",
  "Vardenafil",
  "Varenicline ",
  "Varenzin",
  "Varicella Zoster Vaccine - Live attenuated  ",
  "Varithena",
  "Varivax",
  "Varizig",
  "Varubi",
  "Vascepa",
  "Vaseline",
  "Vaseretic",
  "Vasoflex D1",
  "Vasostrict",
  "Vasotec",
  "Vaxchora",
  "Vaxelis",
  "Vaxneuvance",
  "Vazalore",
  "Vazculep",
  "VCF Contraceptive",
  "Vecamyl",
  "Vectibix",
  "Vectical",
  "Vegzelma",
  "Veklury",
  "Velcade",
  "Veletri",
  "Velphoro",
  "Velsipity",
  "Veltassa",
  "Veltin",
  "Vemlidy",
  "Venclexta",
  "Venelex",
  "Veneno de Abeja Aceite de Vibora",
  "Venetoclax",
  "Venlafaxine",
  "Venofer",
  "Ventavis",
  "Ventipulmin",
  "Ventolin",
  "Ventuss",
  "Venxxiva",
  "Veopoz",
  "Veozah",
  "Veraflox",
  "Verapamil Hydrochloride",
  "Verdeso",
  "Verdrocet",
  "Veregen",
  "Verelan",
  "Veripred",
  "Verkazia",
  "Vermox",
  "Verquvo",
  "Verruguin",
  "Verrustat",
  "Versacloz",
  "Versiclear",
  "Verticalm",
  "Verzenio",
  "Vesicare",
  "Veta-K1",
  "Vetadryl",
  "Vetameg",
  "Vetmedin",
  "Vetoryl",
  "Vetprofen",
  "Vetribute",
  "Vetrimec",
  "Vetrimec Plus",
  "Vetrimycin",
  "VetStarch",
  "Vetsulin",
  "Vevye",
  "Vfend",
  "Vi-Sudo",
  "Viabecline",
  "Viactiv Calcium Plus D",
  "Viagra",
  "Vibativ",
  "Viberzi",
  "Vibramycin",
  "Viceton",
  "Vicoprofen",
  "Victoza",
  "Vidaza",
  "Vigabatrin",
  "Vigadrone",
  "Vigafyde",
  "Vigamox",
  "Vigpoder",
  "Viibryd",
  "Vijoice",
  "Vilanterol+Umeclinidium+Flutocasone Furoate",
  "Vildagliptin",
  "Vildagliptin+Metformin",
  "Viltepso",
  "Vimizim",
  "Vimkunya",
  "Vimovo",
  "Vimpat",
  "Vincasar",
  "Vinorelbine",
  "Viokace",
  "VioNex",
  "Viracept",
  "Viramune",
  "Virasal",
  "Virazole",
  "Virbantel",
  "Viread",
  "Viroptic",
  "Visco-3",
  "Viscoat",
  "Visine",
  "Vistaril",
  "Vistaseal",
  "Vistogard",
  "Visudyne",
  "Vita-Respa",
  "Vitafol-One",
  "Vital E- 500",
  "Vital E- A + D3",
  "Vital E- Newborn",
  "Vital E- Repro",
  "Vitamin D",
  "Vitamins and Minerals Comp",
  "Vitastem",
  "Vitrakvi",
  "Vitrase",
  "Vitron-C Reformulated Jul 2016",
  "Viva-Drops Lubricating Eye Drops",
  "Vivacaine",
  "Vivarin",
  "Vivelle",
  "Vivimusta",
  "Vivitrol",
  "Vivjoa",
  "Vivlodex",
  "Vivotif",
  "Vizimpro",
  "Vizz",
  "Vocabria",
  "Vogelxo",
  "Voltaren",
  "Voluven",
  "Vonjo",
  "Vonvendi",
  "Voquezna",
  "Voranigo",
  "Voraxaze",
  "Voriconazole",
  "Vortioxetine",
  "Vosevi",
  "Vostally",
  "Votrient",
  "Vowst",
  "Voxzogo",
  "Voydeya",
  "Voyxact",
  "Vpriv",
  "Vraylar",
  "Vtama",
  "Vtol",
  "Vuity",
  "Vumerity",
  "Vusion",
  "Vyalev",
  "Vybrique",
  "Vyepti",
  "Vyjuvek",
  "Vykat",
  "Vykoura",
  "Vyleesi",
  "Vyloy",
  "Vyndamax",
  "Vyndaqel",
  "Vyondys 53",
  "Vyscoxa",
  "Vytone",
  "Vytorin",
  "Vyvanse",
  "Vyvgart",
  "Vyvgart Hytrulo",
  "Vyxeos",
  "Vyzulta",
  "Wainua",
  "Wakix",
  "Wal Zyr 24 Hour Allergy",
  "Wal Zyr D",
  "Wal-Act",
  "Wal-Dram",
  "Wal-Dram 2",
  "Wal-Dryl",
  "Wal-Dryl Allergy",
  "Wal-Dryl Childrens",
  "Wal-Dryl PE",
  "Wal-Dryl-D",
  "Wal-Fex",
  "Wal-Fex D",
  "Wal-finate",
  "Wal-Four",
  "Wal-Hist 12 HR Relief",
  "Wal-itin",
  "Wal-itin D",
  "Wal-Mucil",
  "Wal-Phed",
  "Wal-Phed PE",
  "Wal-Profen",
  "Wal-Proxen",
  "Wal-Sleep Z",
  "Wal-Som",
  "Wal-Som (doxylamine)",
  "Wal-Som Maximum Strength",
  "Wal-vert",
  "Wal-Zyr",
  "Wal-Zyr Itchy Eye",
  "Warfarin Sodium",
  "WARTICIDE",
  "Wartstick",
  "Wayrilz",
  "Wegovy",
  "Welchol",
  "Welireg",
  "Wellbutrin",
  "WellPatch",
  "Wellpatch Backache Relief",
  "Welmedix Homecare Pro",
  "Welmedix Homecare Pro Fragile Skin",
  "West Dip",
  "Westcort",
  "Westhroid",
  "Wezlana",
  "Wheat Dextrin (לשעבר Guar Gum)",
  "Widaplik",
  "Wilate",
  "Wilzin",
  "Winlevi",
  "Winrevair",
  "WinRho",
  "Wixela",
  "Wong To Yick",
  "Workvie",
  "Worm Protector 2X",
  "WP Thyroid",
  "Wynzora",
  "Wyost",
  "X-Seb T Pearl",
  "X-Seb T Plus",
  "Xacduro",
  "Xaciato",
  "Xadago",
  "Xalatan",
  "Xalix",
  "Xalkori",
  "Xanax",
  "Xaracoll",
  "Xarelto",
  "Xatmep",
  "Xbryk",
  "Xcopri",
  "Xdemvy",
  "Xeljanz",
  "Xeloda",
  "Xelpros",
  "Xelstrym",
  "Xembify",
  "Xenazine",
  "Xenical",
  "Xenleta",
  "Xenpozyme",
  "Xeomin",
  "Xepi",
  "Xerac AC",
  "Xerava",
  "Xerese",
  "Xermelo",
  "Xgeva",
  "Xhance",
  "Xiaflex",
  "Xiclo",
  "XIFAXAN",
  "Xifyrm",
  "Xigduo",
  "Xiidra",
  "Ximino",
  "Xipere",
  "Xofigo",
  "Xofluza",
  "Xolair",
  "Xolegel",
  "Xolido",
  "Xolremdi",
  "Xopenex",
  "Xospata",
  "Xoten",
  "Xoten-C",
  "Xphozah",
  "Xpovio",
  "Xromi",
  "Xtampza",
  "Xtandi",
  "Xtrenbo",
  "Xulane",
  "Xultophy",
  "Xuriden",
  "Xylimelts",
  "Xylocaine",
  "Xylocaine with Epinephrine",
  "Xylometazoline Hydrochloride",
  "Xylon",
  "Xyntha",
  "Xyosted",
  "Xyrem",
  "Xyvona",
  "Xywav",
  "Xyzal",
  "Yargesa",
  "Yartemlea",
  "Ycanth",
  "Yervoy",
  "Yescarta",
  "Yesintek",
  "Yeztugo",
  "YF-Vax",
  "Yimmugo",
  "Yondelis",
  "Yonsa",
  "Yorvipath",
  "Yosprala",
  "Yuflyma",
  "Yupelri",
  "Yusimry",
  "Yutiq",
  "Yutrepia",
  "Yuvafem",
  "Z Tuss AC",
  "Z-Bum",
  "Z-Guard",
  "Z-Pram",
  "Z-Sleep",
  "Zactran",
  "Zaditor",
  "Zafemy",
  "Zaltrap",
  "Zanaflex",
  "Zanosar",
  "Zantac",
  "Zantac Reformulated Aug 2022",
  "Zapzyt Acne Wash",
  "Zarontin",
  "Zarxio",
  "Zavesca",
  "Zavzpret",
  "Zcaine",
  "Zeasorb",
  "Zebutal",
  "Zegalogue",
  "Zegerid Reformulated Aug 2006",
  "Zegfrovy",
  "Zejula",
  "Zelapar",
  "Zelboraf",
  "Zelnorm",
  "Zelsuvmi",
  "Zelvysia",
  "Zemaira",
  "Zembrace",
  "Zemdri",
  "Zemplar",
  "Zenalpha",
  "Zenatane",
  "Zencia Wash",
  "Zeniquin",
  "Zenpep",
  "Zenrelia",
  "Zensa",
  "Zentrip",
  "Zenzedi",
  "Zepatier",
  "Zepbound",
  "Zephiran",
  "Zephrex-D",
  "Zeposia",
  "Zepzelca",
  "Zerbaxa",
  "Zerviate",
  "Zestoretic",
  "Zestril",
  "Zetamine",
  "Zetia",
  "Zetonna",
  "Zevaskyn",
  "Zevtera",
  "Ziac",
  "Ziagen",
  "Ziana",
  "Zicam Cough",
  "Zicam Sinus Relief",
  "Zidovudine",
  "Ziextenzo",
  "Ziihera",
  "ZIKS Pain Relief",
  "Zilactin B",
  "Zilactin Cold Sore",
  "Zilactin-L Cold Sore Liquid",
  "Zilbrysq",
  "Zilretta",
  "Zilxi",
  "Zimecterin",
  "Zimecterin Gold",
  "Zimhi",
  "Zincon",
  "Zingo",
  "Zinotic",
  "Zinotic ES",
  "Zinplava",
  "Zionodil",
  "Zioptan",
  "Ziprasidone",
  "Zipsor",
  "Zirabev",
  "Zirgan",
  "Zit Stick",
  "Zithranol",
  "Zithromax",
  "Zituvimet",
  "Zituvio",
  "Zocor",
  "Zodryl AC",
  "Zodryl DAC",
  "Zodryl DEC",
  "Zohydro",
  "Zokinvy",
  "Zoladex",
  "Zoledronic Acid",
  "Zoletil",
  "Zolgensma",
  "Zolinza",
  "Zolmitriptan",
  "Zoloft",
  "Zolpidem Tartrate",
  "Zolpimist",
  "Zolymbus",
  "Zomacton",
  "Zomig",
  "Zonalon",
  "Zonatuss",
  "Zonegran",
  "Zonisade",
  "Zontivity",
  "Zooby Fluoride Foam",
  "Zopiclone",
  "Zorbium",
  "Zorbtive",
  "Zorcaine",
  "Zortress",
  "Zorvolex",
  "Zoryve",
  "Zostrix",
  "Zostrix Joint & Arthritis Pain Relief",
  "Zostrix Sports",
  "Zosyn",
  "Zotex C",
  "Zovirax",
  "Ztalmy",
  "ZTlido",
  "Zubsolv",
  "Zuclopenthixol Acetate",
  "Zulresso",
  "Zunveyl",
  "Zuplenz",
  "Zuprevo",
  "Zurnai",
  "Zurzuvae",
  "Zusduri",
  "Zybic",
  "Zyclara",
  "Zycortal",
  "Zycosan",
  "Zycubo",
  "Zydaclin",
  "Zydelig",
  "Zyflo",
  "Zygolide",
  "Zykadia",
  "Zylet",
  "Zyloprim",
  "Zymaxid",
  "Zymfentra",
  "Zynlonta",
  "Zynrelef",
  "Zynteglo",
  "Zynyz",
  "Zypitamag",
  "ZyPram",
  "Zyprexa",
  "Zyrtec",
  "Zyrtec-D",
  "Zytiga",
  "Zyvox",
  "ZZZ Sleep",
  "Zzzquil",
  "Zzzquil Ultra"
]
